// import React, { useState, useEffect } from "react";
// import Loader from "../utils/loader";
// import clsx from "clsx";
// import { makeStyles } from "@material-ui/core/styles";
// import TextField from "@material-ui/core/TextField";
// import userService from "../services/userService";
// import { toast, ToastContainer } from "react-toastify";
// import CryptoJS from "crypto-js";
// import Group244 from "../static/Group244.png";
// import Group5702x from "../static/Group5702x.png";
// import { Link, withRouter } from "react-router-dom";
// // import FormControl from "@material-ui/core/FormControl";
// import IconButton from "@material-ui/core/IconButton";
// import Input from "@material-ui/core/Input";
// import InputLabel from "@material-ui/core/InputLabel";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Visibility from "@material-ui/icons/Visibility";
// import VisibilityOff from "@material-ui/icons/VisibilityOff";
// import "./LoginForm.css";
// import { getHomeCMS } from "../services/adminServices";
// import {
//   Card,
//   InputGroup,
//   FormControl,
//   Form,
//   Button,
//   ButtonGroup,
//   Carousel,
// } from "react-bootstrap";
// import loginBackground from "../static/loginBackground.png";
// import PetLogo from "../static/POET_Logo_Mid.png";
// import googleSignin from "../static/signup_login/googleSignin.png";
// import facebookSignin from "../static/signup_login/facebookSignin.png";
// import tick from "../static/signup_login/Check.png";

// import Login1 from "../static/signupBg.png";
// import InputBoxMui from "./ReusableComponents/InputBoxMui";
// import CheckboxMui from "./ReusableComponents/CheckBoxMui";
// import InputBoxPasswordMui from "./ReusableComponents/InputBoxPasswordMui";
// import InputBoxMobile from "./ReusableComponents/InputBoxforMobile";
// import SelectDropdownMui from "./ReusableComponents/SelectDropdownMui";
// import OtpInputBox from "./ReusableComponents/OtpInputBox";
// import { checkOtpStatus, sendOtp, verifyOtp } from "../services/authService";
// import { countries } from "./ReusableComponents/countryList";
// import { getRoles } from "../services/roleServices";
// import { addUserLogs } from "../services/userLogServices";
// import PoetNewlogopen from "../static/loginlogo.png";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     display: "flex",
//     flexWrap: "wrap",
//   },
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     width: "100%",
//   },
//   dense: {
//     marginTop: 19,
//   },
// }));

// function SignUp({ history }) {
//   const classes = useStyles();
//   const [email, setEmail] = useState("");
//   const [values, setValues] = useState("");
//   const [username, setUserName] = useState("");
//   const [organizationName, setOrganizationName] = useState("");
//   const [organizationId, setOrganizationId] = useState("");
//   const [password, setPassword] = useState("");
//   const [isTermsAccepted, setAcceptTerms] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState("");
//   const [disable, setdisable] = useState(true);
//   const [showPassword] = useState(false);
//   const [cms, setCms] = useState({});
//   const [roleList, setRoleList] = useState([
//     {
//       value: "Individual",
//       name: "Individual",
//     },
//     {
//       value: "Organization",
//       name: "Organization",
//     },
//   ]);
//   const [role, setRole] = useState("");
//   const [userRoleList, setUserRoleList] = useState([]);
//   const [userRole, setUserRole] = useState("");
//   const [region, setRegion] = useState("");
//   const [countryList, setCountryList] = useState([]);
//   const [otpValue, setOtpValue] = useState("");
//   const [countryCode, setCountryCode] = useState("");
//   const [mobileNo, setMobileNo] = useState("");
//   const [isOtpShown, setIsOtpShown] = useState(false);
//   const [isOtpVerify, setIsOtpVerify] = useState(false);
//   const [verifyDisable, setVerifyDisable] = useState(true);
//   const [timer, setTimer] = useState(0);
//   const [isResendCodeDisable, setisResendCodeDisable] = useState(true);
//   const [isResendButton, setIsResendButton] = useState(false);
//   const [isPasswordValid, setIsPasswordValid] = useState(true);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [showRoles, setShowRoles] = useState(false);
//   const [otpErrorMsg, setErrorMsg] = useState(null);

//   const selectedCountry = countries.find(
//     (country) => country.phone === countryCode.slice(1),
//   );
//   const countryName = selectedCountry ? selectedCountry.label : "";
//   const getCms = async () => {
//     let cms = await getHomeCMS();
//     setCms(cms.data);
//     console.log(cms);
//   };

//   useEffect(() => {
//     getCms();
//   }, []);

//   async function handleRegisterSubmit() {
//     if (!username) {
//       toast.warn("Please enter the username");
//       return;
//     }
//     if (!email) {
//       toast.warn("Please enter the email");
//       return;
//     }
//     // Email validation using a regular expression
//     const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailPattern.test(email)) {
//       toast.warn("Please enter a valid email address.");
//       return;
//     }

//     if (role == "Organization") {
//       // if (!region) {
//       //     setLoading(false);
//       //     toast.warn("Please enter Region");
//       //     return
//       // }
//       if (!organizationName) {
//         toast.warn("Please enter Organization Name");
//         return;
//       }
//       if (!organizationId) {
//         toast.warn("Please enter Organization ID");
//         return;
//       }
//       if (!userRole) {
//         toast.warn("Please select User Role");
//         return;
//       }
//     }
//     if (!password) {
//       toast.warn("Please enter the password");
//       return;
//     }
//     if (!mobileNo) {
//       toast.warn("Please enter the Mobile Number");
//       return;
//     }
//     if (!isTermsAccepted) {
//       toast.warn("Please accept the Terms & Conditions");
//       return;
//     }
//     if (password.length < 6) {
//       toast.warn("Password must contain at least 6 characters");
//     } else {
//       const hashedPassword = CryptoJS.SHA256(password).toString();
//       let user = {
//         username: username,
//         email: email,
//         // password: password,
//         password: hashedPassword,
//         phone: countryCode + mobileNo,
//         // organizationId: organizationId,
//         // organizationName: organizationName,
//         referedEmail:
//           localStorage.getItem("referedEmail") !== "undefined" || null
//             ? localStorage.getItem("referedEmail")
//             : "",
//         Role: role,
//         organizationName: role == "Organization" ? organizationName : "",
//         organizationId: role == "Organization" ? organizationId : "",
//         userRole: role == "Organization" ? userRole : "",
//         // region: role == "Organization" && region,
//         country: countryName,
//       };
//       console.log("user_", user);
//       setLoading(true);
//       const result = await userService.register(user);
//       setLoading(false);
//       console.log(result);
//       if (result.status !== 201) {
//         if (result?.Role == "Individual") {
//           toast.info(result.message);
//           history.push({
//             pathname: `/afterRegistration`,
//             state: { detail: user },
//           });
//         } else {
//           toast.warn(result.message);
//         }
//       } else {
//         localStorage.removeItem("referedEmail");
//         localStorage.removeItem("accountType");
//         toast.info(result.message);
//         if (!result?.users) {
//           history.push({
//             pathname: `/afterRegistration`,
//             state: { detail: user },
//           });
//         }
//         try {
//           const data = {
//             userId: result?.data?._id,
//             organizationId: result?.data?.organizationId,
//             actionType: "signup",
//           };
//           const addLogs = await addUserLogs(data);
//           if (addLogs.status !== 200) {
//             toast.error(addLogs.message);
//           }
//         } catch (error) {
//           toast.error("Internal server error");
//         }

//         // toast.info("Please check your email to verify");
//       }
//     }
//   }
//   function handleAcceptTerms(e) {
//     console.log("value", e.target.checked);
//     const isChecked = e.target.checked;
//     setAcceptTerms(isChecked);
//   }
//   function handlePassword(e) {
//     let pass = e.target.value;

//     if (pass.length > 0) {
//       if (pass.length <= 7) {
//         setErrors("Password contains minimum 8 Characters");
//         setIsPasswordValid(false);
//       } else {
//         setErrors("");

//         var upperCaseLetters = /[A-Z]/g;
//         var numbers = /[0-9]/g;
//         var specialCharacters = /[!@#$%^&*(),.?":{}|<>]/g;
//         if (!pass.match(upperCaseLetters)) {
//           setErrors("Password contains at least 1 Capital letter");
//           setIsPasswordValid(false);
//         } else if (!pass.match(numbers)) {
//           setErrors("Password contains at least 1 number");
//           setIsPasswordValid(false);
//         } else if (!pass.match(specialCharacters)) {
//           setErrors("Password contains at least 1 special character");
//           setIsPasswordValid(false);
//         } else {
//           setErrors("");
//           setIsPasswordValid(true);
//           setPassword(pass);
//         }
//       }
//     } else {
//       setErrors("");
//       setIsPasswordValid(true);
//     }
//   }

//   const handleClickShowPassword = () => {
//     setValues({ ...values, showPassword: !values.showPassword });
//   };

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };

//   const handleRole = (e) => {
//     console.log("eData_", e);
//     setRole(e.target.value);
//   };

//   const handleUserRole = (e) => {
//     console.log("eData_11111_", e);
//     setUserRole(e.target.value);
//   };

//   const handleRegion = (e) => {
//     console.log("handleRegion", e, region);
//     setRegion(e.target.value);
//   };

//   const handleCountry = (event, value) => {
//     console.log("params_", event, value);
//     if (value.phone !== "" && mobileNo !== "") {
//       setVerifyDisable(false);
//       setIsOtpShown(false);
//       setIsResendButton(false);
//     } else {
//       setVerifyDisable(true);
//     }
//     setCountryCode(`+${value.phone}`);
//   };
//   const handleNumber = (e) => {
//     console.log("eData_", e, e.length, countryCode);

//     // Map for country-specific phone number lengths
//     const countryLengthMap = {
//       "+1": 10,
//       "+93": 9, // Afghanistan
//       "+355": 8, // Albania
//       "+213": 9, // Algeria
//       "+376": 6, // Andorra
//       "+244": 9, // Angola
//       "+1-264": 10, // Anguilla
//       "+1-268": 10, // Antigua and Barbuda
//       "+54": 10, // Argentina
//       "+374": 8, // Armenia
//       "+297": 7, // Aruba
//       "+61": 9, // Australia
//       "+43": 13, // Austria
//       "+994": 9, // Azerbaijan
//       "+1-242": 10, // Bahamas
//       "+973": 8, // Bahrain
//       "+880": 11, // Bangladesh
//       "+1-246": 10, // Barbados
//       "+32": 9, // Belgium
//       "+501": 8, // Belize
//       "+229": 8, // Benin
//       "+1-441": 10, // Bermuda
//       "+975": 8, // Bhutan
//       "+591": 8, // Bolivia
//       "+387": 8, // Bosnia and Herzegovina
//       "+267": 7, // Botswana
//       "+55": 11, // Brazil
//       "+1-284": 10, // British Virgin Islands
//       "+673": 7, // Brunei
//       "+359": 8, // Bulgaria
//       "+226": 8, // Burkina Faso
//       "+257": 7, // Burundi
//       "+855": 8, // Cambodia
//       "+237": 9, // Cameroon
//       "+1": 10, // Canada
//       "+238": 7, // Cape Verde
//       "+1-345": 10, // Cayman Islands
//       "+236": 7, // Central African Republic
//       "+235": 8, // Chad
//       "+56": 9, // Chile
//       "+86": 11, // China
//       "+61": 9, // Christmas Island
//       "+61": 9, // Cocos (Keeling) Islands
//       "+57": 10, // Colombia
//       "+269": 7, // Comoros
//       "+242": 7, // Congo
//       "+243": 9, // Democratic Republic of the Congo
//       "+682": 5, // Cook Islands
//       "+506": 8, // Costa Rica
//       "+225": 10, // Côte d'Ivoire
//       "+385": 9, // Croatia
//       "+53": 8, // Cuba
//       "+599": 7, // Curaçao
//       "+357": 8, // Cyprus
//       "+420": 9, // Czech Republic
//       "+45": 8, // Denmark
//       "+253": 6, // Djibouti
//       "+1-767": 10, // Dominica
//       "+1-809": 10, // Dominican Republic
//       "+593": 9, // Ecuador
//       "+20": 10, // Egypt
//       "+503": 8, // El Salvador
//       "+240": 9, // Equatorial Guinea
//       "+291": 7, // Eritrea
//       "+368": 6, // Estonia
//       "+251": 10, // Ethiopia
//       "+500": 4, // Falkland Islands
//       "+298": 6, // Faroe Islands
//       "+679": 7, // Fiji
//       "+358": 9, // Finland
//       "+33": 9, // France
//       "+594": 9, // French Guiana
//       "+689": 6, // French Polynesia
//       "+241": 7, // Gabon
//       "+220": 7, // Gambia
//       "+995": 9, // Georgia
//       "+49": 11, // Germany
//       "+233": 10, // Ghana
//       "+350": 5, // Gibraltar
//       "+30": 10, // Greece
//       "+299": 6, // Greenland
//       "+1-473": 10, // Grenada
//       "+590": 10, // Guadeloupe
//       "+1-671": 10, // Guam
//       "+502": 8, // Guatemala
//       "+224": 9, // Guinea
//       "+245": 9, // Guinea-Bissau
//       "+595": 9, // Paraguay
//       "+509": 9, // Haiti
//       "+379": 13, // Holy See
//       "+504": 8, // Honduras
//       "+852": 8, // Hong Kong
//       "+36": 9, // Hungary
//       "+354": 7, // Iceland
//       "+91": 10, // India
//       "+62": 10, // Indonesia
//       "+98": 10, // Iran
//       "+964": 10, // Iraq
//       "+353": 9, // Ireland
//       "+972": 9, // Israel
//       "+39": 10, // Italy
//       "+1-876": 10, // Jamaica
//       "+81": 10, // Japan
//       "+44": 10, // Jersey
//       "+962": 9, // Jordan
//       "+7": 10, // Kazakhstan
//       "+254": 10, // Kenya
//       "+686": 5, // Kiribati
//       "+965": 8, // Kuwait
//       "+996": 9, // Kyrgyzstan
//       "+856": 8, // Laos
//       "+371": 8, // Latvia
//       "+961": 8, // Lebanon
//       "+266": 8, // Lesotho
//       "+231": 7, // Liberia
//       "+218": 10, // Libya
//       "+423": 7, // Liechtenstein
//       "+370": 8, // Lithuania
//       "+352": 8, // Luxembourg
//       "+261": 10, // Madagascar
//       "+265": 8, // Malawi
//       "+60": 10, // Malaysia
//       "+960": 7, // Maldives
//       "+223": 8, // Mali
//       "+356": 8, // Malta
//       "+692": 7, // Marshall Islands
//       "+596": 10, // Martinique
//       "+222": 9, // Mauritania
//       "+230": 8, // Mauritius
//       "+262": 10, // Mayotte
//       "+52": 10, // Mexico
//       "+691": 7, // Micronesia
//       "+373": 8, // Moldova
//       "+377": 8, // Monaco
//       "+976": 8, // Mongolia
//       "+1-664": 10, // Montserrat
//       "+212": 9, // Morocco
//       "+258": 9, // Mozambique
//       "+95": 9, // Myanmar
//       "+264": 9, // Namibia
//       "+674": 8, // Nauru
//       "+977": 10, // Nepal
//       "+31": 9, // Netherlands
//       "+599": 10, // Netherlands Antilles
//       "+687": 6, // New Caledonia
//       "+64": 9, // New Zealand
//       "+505": 8, // Nicaragua
//       "+227": 8, // Niger
//       "+234": 10, // Nigeria
//       "+683": 5, // Niue
//       "+64": 9, // Norfolk Island
//       "+850": 8, // North Korea
//       "+1-670": 10, // Northern Mariana Islands
//       "+47": 8, // Norway
//       "+968": 8, // Oman
//       "+92": 10, // Pakistan
//       "+680": 7, // Palau
//       "+970": 9, // Palestine
//       "+507": 8, // Panama
//       "+675": 7, // Papua New Guinea
//       "+595": 8, // Paraguay
//       "+51": 9, // Peru
//       "+63": 10, // Philippines
//       "+48": 9, // Poland
//       "+351": 9, // Portugal
//       "+1-787": 10, // Puerto Rico
//       "+974": 8, // Qatar
//       "+40": 10, // Romania
//       "+7": 10, // Russia
//       "+250": 10, // Rwanda
//       "+590": 10, // Saint Barthélemy
//       "+1-869": 10, // Saint Kitts and Nevis
//       "+1-758": 10, // Saint Lucia
//       "+1-784": 10, // Saint Vincent and the Grenadines
//       "+685": 5, // Samoa
//       "+378": 10, // San Marino
//       "+239": 7, // Sao Tome and Principe
//       "+966": 9, // Saudi Arabia
//       "+221": 9, // Senegal
//       "+381": 9, // Serbia
//       "+248": 7, // Seychelles
//       "+232": 8, // Sierra Leone
//       "+65": 8, // Singapore
//       "+421": 9, // Slovakia
//       "+386": 8, // Slovenia
//       "+677": 6, // Solomon Islands
//       "+252": 8, // Somalia
//       "+27": 10, // South Africa
//       "+82": 10, // South Korea
//       "+211": 9, // South Sudan
//       "+34": 9, // Spain
//       "+94": 10, // Sri Lanka
//       "+249": 10, // Sudan
//       "+597": 8, // Suriname
//       "+268": 7, // Eswatini
//       "+41": 9, // Switzerland
//       "+963": 9, // Syria
//       "+886": 10, // Taiwan
//       "+992": 9, // Tajikistan
//       "+255": 10, // Tanzania
//       "+66": 9, // Thailand
//       "+670": 7, // Timor-Leste
//       "+228": 8, // Togo
//       "+690": 6, // Tokelau
//       "+676": 4, // Tonga
//       "+1-868": 10, // Trinidad and Tobago
//       "+216": 8, // Tunisia
//       "+90": 10, // Turkey
//       "+993": 9, // Turkmenistan
//       "+1-649": 10, // Turks and Caicos Islands
//       "+688": 5, // Tuvalu
//       "+256": 10, // Uganda
//       "+380": 9, // Ukraine
//       "+971": 9, // United Arab Emirates
//       "+44": 10, // United Kingdom
//       "+1": 10, // United States
//       "+598": 8, // Uruguay
//       "+998": 9, // Uzbekistan
//       "+678": 5, // Vanuatu
//       "+379": 13, // Vatican City
//       "+58": 10, // Venezuela
//       "+84": 10, // Vietnam
//       "+681": 4, // Wallis and Futuna
//       "+212": 9, // Western Sahara
//       "+967": 9, // Yemen
//       "+260": 10, // Zambia
//       "+263": 9, // Zimbabwe
//       "+1684": 7, // American Samoa (AS)
//       "+358-18": 9, // Åland Islands (AX)
//       "+590": 10, // Saint Barthélemy (BL)
//       "+375": 9, // Belarus (BY)
//       "+501": 8, // Belize (BZ)
//       "+383": 9, // Kosovo (XK)
//       "+1-340": 10, // United States Virgin Islands (VI)
//       "+1-284": 10, // British Virgin Islands (VG)
//       "+690": 4, // Tokelau (TK)
//       "+262": 9, // French Southern Territories (TF)
//       "+235": 8, // Chad (TD)
//       "+239": 7, // São Tomé and Príncipe (ST)
//       "+268": 7, // Eswatini (SZ)
//       "+290": 4, // Saint Helena (SH)
//       "+46": 10, // Sweden (SE)
//       "+262": 9, // Réunion (RE)
//       "+872": 9, // Pitcairn Islands (PN)
//       "+382": 9, // Montenegro (ME)
//       "+389": 9, // North Macedonia (MK)
//       "+269": 7, // Comoros (KM)
//       "+44": 10, // Jersey (JE)
//       "+44": 10, // Isle of Man (IM)
//       "+672": 6, // Heard Island and McDonald Islands (HM)
//       "+592": 9, // Guyana (GY)
//       "+500": 4, // South Georgia and the South Sandwich Islands (GS)
//       "+500": 4, // Falkland Islands (FK)
//     };

//     // Get the required length for the given country code
//     const maxLength = countryLengthMap[countryCode] || 10; // Default to 10 if country code isn't found

//     // Validation based on country-specific length
//     if (e.length > maxLength) {
//       return;
//     }

//     // Set error message if the length is less than required
//     if (e.length < maxLength && e.length > 0) {
//       setErrorMessage(`Please enter a ${maxLength} digit phone number.`);
//     } else {
//       setErrorMessage("");
//     }

//     // Check for valid lengths for China or other countries
//     let isChina = e.length === 11 && countryCode === "+86";
//     let isOtherCountries =
//       e.length === maxLength && countryCode !== "+86" && countryCode !== "";

//     if (isChina || isOtherCountries) {
//       setVerifyDisable(false);
//       setIsOtpShown(false);
//       setIsResendButton(false);
//     } else {
//       setVerifyDisable(true);
//     }

//     setMobileNo(e);
//   };
//   const handleOTP = async (e) => {
//     console.log("otpdata_", e.length, e);
//     setOtpValue(e);

//     if (e.length == 6) {
//       setLoading(true);
//       let payload = {
//         phone: countryCode + mobileNo,
//         otp: e,
//       };
//       let verifyOtpresponse = await verifyOtp(payload);
//       console.log("verifyOtp_", verifyOtpresponse);
//       if (verifyOtpresponse.status == 200) {
//         setLoading(false);
//         setIsOtpShown(false);
//         setIsOtpVerify(true);
//         setVerifyDisable(true);
//         setdisable(false);
//         setisResendCodeDisable(false);
//         setIsResendButton(false);
//       } else if (verifyOtpresponse.status == 400) {
//         console.log("bnbnbnb");
//         setLoading(false);
//         setIsOtpVerify(false);
//         setIsOtpShown(true);
//         setisResendCodeDisable(true);
//         setIsResendButton(true);
//         setErrorMsg(verifyOtpresponse.message);
//         return;
//       } else if (verifyOtpresponse.status == 429) {
//         console.log("bnbvvnbnb");
//         setLoading(false);
//         setIsOtpVerify(false);
//         setIsOtpShown(true);
//         setisResendCodeDisable(true);
//         setIsResendButton(true);
//         setErrorMsg(verifyOtpresponse.message);
//         return;
//       } else {
//         setLoading(false);
//         setIsOtpVerify(false);
//         setIsOtpShown(true);
//         setisResendCodeDisable(true);
//         setIsResendButton(true);
//       }
//     }
//   };

//   // useEffect(()=>{
//   //     if(role !=="" && username !== "" && email !== "" && mobileNo !== "" && password !== ""){
//   //         setdisable(false)
//   //     } else{
//   //         setdisable(true)
//   //     }
//   // },[role,username,email,mobileNo,password])

//   const handleVerify = async () => {
//     console.log("resendOTP");
//     setOtpValue("");
//     setTimer(60);
//     // setVerifyDisable(true)
//     setIsOtpVerify(false);
//     // setIsOtpShown(false)
//     if (!role) {
//       toast.warn("Please select role.");
//       return;
//     }
//     if (!isPasswordValid) {
//       toast.warn("Please enter a valid password.");
//       return;
//     }
//     if (!username) {
//       toast.warn("Please enter the username");
//       return;
//     }
//     if (!email) {
//       toast.warn("Please enter the email");
//       return;
//     }
//     if (role == "Organization") {
//       if (!organizationName) {
//         toast.warn("Please enter Organization Name");
//         return;
//       }
//       if (!organizationId) {
//         toast.warn("Please enter Organization ID");
//         return;
//       }
//       if (!userRole) {
//         toast.warn("Please select User Role");
//         return;
//       }
//     }
//     if (!password) {
//       toast.warn("Please enter the password");
//       return;
//     }
//     if (!mobileNo) {
//       toast.warn("Please enter the Mobile Number");
//       return;
//     }

//     let payload = {
//       // "email": email,
//       phone: countryCode + mobileNo,
//     };

//     // Check OTP status before proceeding
//     let otpStatusResponse = await checkOtpStatus(payload); // Backend call to get OTP status
//     if (otpStatusResponse.status === 200) {
//       let otpDetails = otpStatusResponse.data;
//       let currentTime = new Date();

//       // Check if the user is currently locked
//       if (
//         otpDetails.lockUntil &&
//         new Date(otpDetails.lockUntil) > currentTime &&
//         otpDetails.attempts == 3
//       ) {
//         let unlockTime = new Date(otpDetails.lockUntil).toLocaleString();
//         toast.warn(
//           `You are locked due to failed attempts. Try again after ${unlockTime}.`,
//         );
//         return;
//       }

//       if (
//         otpDetails.lockUntil &&
//         new Date(otpDetails.lockUntil) > currentTime
//       ) {
//         let unlockTime = new Date(otpDetails.lockUntil).toLocaleString();
//         toast.warn(
//           `You are locked due to failed attempts. Try again after ${unlockTime}.`,
//         );
//         return;
//       }
//     }

//     let sentresponse = await sendOtp(payload);
//     console.log("sentresponse_", sentresponse.message);

//     if (sentresponse.status == 200) {
//       toast.success("OTP Sent Successfully");
//       setIsResendButton(true);
//       setIsOtpShown(true);
//       setVerifyDisable(true);
//     } else {
//       toast.warn("Invalid Phone Number");
//       return;
//     }
//   };

//   useEffect(() => {
//     const timerId = setTimeout(() => {
//       if (timer > 0) {
//         setTimer(timer - 1);
//       }
//     }, 1000);
//     if (timer == 0) {
//       setisResendCodeDisable(false);
//       setIsOtpShown(false);
//     } else {
//       setisResendCodeDisable(true);
//     }
//     return () => {
//       clearTimeout(timerId);
//     };
//   }, [timer]);

//   const formatTime = (time) => {
//     const minutes = Math.floor(time / 60);
//     const seconds = time % 60;
//     return `${minutes.toString().padStart(2, "0")}:${seconds
//       .toString()
//       .padStart(2, "0")}`;
//   };

//   useEffect(() => {
//     fetchCountryList();
//   }, []);

//   const fetchCountryList = () => {
//     let finalArr = [];
//     countries.map((obj) => {
//       finalArr.push({
//         name: obj.label,
//         value: obj.label,
//       });
//     });
//     setCountryList(finalArr);
//   };

//   const getUserRoles = async () => {
//     try {
//       if (organizationId) {
//         setLoading(true);
//         const data = { organizationId };
//         const checkUsersExist = await getRoles(data);
//         if (checkUsersExist?.isUsersExist) {
//           setUserRoleList(checkUsersExist?.userRoleList);
//         } else {
//           setUserRoleList(checkUsersExist?.userRoleList);
//         }
//         setShowRoles(true);
//         setLoading(false);
//       }
//     } catch (error) {
//       console.error("Error finding roles list:", error);
//       setLoading(false);
//     }
//   };

//   // useEffect(() => {
//   //   getUserRoles();
//   // }, [organizationId]);

// useEffect(() => {
//   if (!organizationId || role !== "Organization") {
//     setShowRoles(false);
//     return;
//   }

//   const timer = setTimeout(() => {
//     getUserRoles();
//   }, 2000);

//   return () => clearTimeout(timer);
// }, [organizationId]);

//   return (
//     <div
//       className="container-fluid-login"
//       style={{
//         backgroundImage: `url(${Login1})`,
//         backgroundSize: "cover",
//         backgroundRepeat: "no-repeat",
//         backgroundPosition: "center",
//         height: "100%",
//         position: "absolute",
//         top: 0,
//         left: 0,
//         // position: "relative"
//       }}
//     >
//       <ToastContainer />
//       <Loader loading={loading} />
//       <div className="d-flex col-md-12 align-items-center">
//         <div className="petLogoContainer">
//           <Link to="/">
//             <img src={PoetNewlogopen} alt="Logo" className="petLogo" />
//           </Link>
//         </div>
//         <div className="col-md-12">
//           <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
//             <Card className="card-comp px-5 p-3">
//               <div className="text-center">
//                 <h3 className="mainHeading">Signup</h3>
//               </div>
//               <div className="mt-3 py-1">
//                 <SelectDropdownMui
//                   optionsList={roleList}
//                   selectLabel={"Role"}
//                   onChange={handleRole}
//                   value={role}
//                 />
//               </div>

//               {/* <div className="py-2">
//                             <InputBoxMui
//                                 fullWidth
//                                 type="text"
//                                 label="Role"
//                                 // value={username}
//                                 onChange={(e) => setUserName(e.target.value)}
//                             // placeholder="Username"
//                             />
//                         </div> */}

//               {role == "Organization" && (
//                 <>
//                   {/* <div className="mt-2 py-1">
//                                     <SelectDropdownMui
//                                         optionsList={countryList}
//                                         selectLabel={"Region*"}
//                                         onChange={handleRegion}
//                                         value={region}
//                                     />
//                                 </div> */}

//                   <div className="mt-2 py-1">
//                     <InputBoxMui
//                       fullWidth
//                       type="text"
//                       label="Organization*"
//                       // value={username}
//                       onChange={(e) => setOrganizationName(e.target.value)}
//                       // placeholder="Username"
//                     />
//                   </div>

//                   <div className=" mt-2 py-1">
//                     <InputBoxMui
//                       fullWidth
//                       type="text"
//                       label="Organization ID*"
//                       // value={username}
//                       // onChange={(e) => setOrganizationId(e.target.value)}
//                       onChange={(e) => {
//                         setOrganizationId(e.target.value);
//                         setUserRole("");
//                         setShowRoles(false);
//                       }}
//                       // placeholder="Username"
//                     />
//                   </div>

//                   {organizationId && showRoles && (
//                     <div className="mt-2 py-1">
//                       <SelectDropdownMui
//                         optionsList={userRoleList}
//                         selectLabel={"User Role"}
//                         onChange={handleUserRole}
//                         value={userRole}
//                       />
//                     </div>
//                   )}
//                 </>
//               )}

//               <div className="mt-2 py-1">
//                 <InputBoxMui
//                   fullWidth
//                   type="text"
//                   label="Username*"
//                   // value={username}
//                   onChange={(e) => setUserName(e.target.value)}
//                   // placeholder="Username"
//                 />
//               </div>

//               <div className="mt-2 py-1">
//                 <InputBoxMui
//                   fullWidth
//                   type="email"
//                   label="Email*"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   // placeholder="Email"
//                 />
//                 {/* <p className="p-2" style={{ color: "red", fontSize: "10px", textAlign: "left" }}>
//                                 {emailerrors}
//                             </p> */}
//               </div>

//               <div className="mt-2 py-1">
//                 <InputBoxPasswordMui
//                   fullWidth
//                   label="Password*"
//                   type={values.showPassword ? "text" : "password"}
//                   value={values.password}
//                   onChange={(e) => handlePassword(e)}
//                   // placeholder="Password"
//                 />
//                 <p
//                   className="p-2"
//                   style={{ color: "red", fontSize: "10px", textAlign: "left" }}
//                 >
//                   {errors}
//                 </p>
//               </div>
//               <div className="mt-2 py-1 row">
//                 <div className="col-md-9">
//                   <InputBoxMobile
//                     onChange={(e) => handleNumber(e)} // Ensure to pass the value
//                     handleCountryCode={handleCountry}
//                     value={mobileNo}
//                   />
//                   {/* {errorMessage && <div className="text-danger">{errorMessage}</div>} Display error message */}
//                 </div>
//                 <Button
//                   variant="primary"
//                   className="loginBtnVerify"
//                   disabled={verifyDisable}
//                   onClick={handleVerify}
//                 >
//                   Verify
//                 </Button>
//                 {errorMessage && (
//                   <div
//                     className="text-danger"
//                     style={{ margin: "15px 15px 0px 15px" }}
//                   >
//                     {errorMessage}
//                   </div>
//                 )}
//               </div>

//               {isOtpShown && (
//                 <>
//                   <div className="mt-2 d-flex justify-content-center">
//                     <OtpInputBox
//                       value={otpValue}
//                       onChange={(e) => handleOTP(e)}
//                     />
//                   </div>
//                   {!isOtpVerify && otpValue?.length == 6 && (
//                     <div>
//                       {otpErrorMsg && (
//                         <p className="errorMsg mt-1">{otpErrorMsg}</p>
//                       )}
//                       {/* <p className="errorMsg mt-1">Please enter the correct OTP </p> */}
//                     </div>
//                   )}
//                 </>
//               )}

//               <div className="mt-2 d-flex">
//                 {isResendButton && (
//                   <Button
//                     className="otpresend p-0"
//                     onClick={handleVerify}
//                     disabled={isResendCodeDisable}
//                   >
//                     Resend Code
//                   </Button>
//                 )}
//                 {/* <a href="handleResend">Resend Code</a> */}
//                 {isOtpShown && (
//                   <p className="ml-5"> {isOtpShown && formatTime(timer)}</p>
//                 )}
//               </div>

//               {isOtpVerify && (
//                 <div className="d-flex mt-2">
//                   <p className="verifyMsg">Phone Number Verified </p>
//                   <img className="tickicon ml-2 mt-1" src={tick}></img>
//                 </div>
//               )}

//               <div className="">
//                 <CheckboxMui
//                   label="I agree with terms and conditions"
//                   isChecked={isTermsAccepted}
//                   onChange={(e) => handleAcceptTerms(e)}
//                 />
//               </div>

//               <div
//                 className="text-center"
//                 // style={{ marginTop: "2%" }}
//               >
//                 <Button
//                   variant="primary"
//                   className="loginBtnRegister"
//                   disabled={disable}
//                   onClick={handleRegisterSubmit}
//                 >
//                   Sign up
//                 </Button>
//               </div>

//               <div className="text-center mt-1">
//                 <p
//                   style={{
//                     // fontSize: "10px",
//                     fontSize: "0.9rem",
//                     lineHeight: "1.67",
//                     textAlign: "center",
//                     color: "#43425d",
//                   }}
//                 >
//                   Already have an account?{" "}
//                   <Link
//                     to="/login"
//                     className="signinLink"
//                     style={{ cursor: "pointer", fontSize: "0.9rem" }}
//                   >
//                     Login
//                   </Link>
//                 </p>
//               </div>

//               {/* {role !== "Organization" &&
//                             <>
//                                 <p className="hr-lines ">OR</p>
//                                 <div className="text-center">
//                                     <Button
//                                         variant="primary"
//                                         className="smBtn"
//                                         href="https://api.mypoet360.com/api/auth/google"
//                                         // href={`${apiUrl}/auth/google`}
//                                     >
//                                         <img
//                                             className="smImg"
//                                             src={googleSignin}
//                                         />
//                                         <a
//                                             href="https://api.mypoet360.com/api/auth/google"
//                                             // className="googlefblink"
//                                         >Sign up with <strong>Google</strong></a>

//                                     </Button>
//                                 </div>

//                                 <div className="mt-2 text-center">
//                                     <Button
//                                         variant="primary"
//                                         className="smBtn"
//                                         // href="https://api.mypoet360.com/api/auth/facebook"
//                                         href={`${apiUrl}/auth/facebook`}
//                                     >
//                                         <img
//                                             className="smImg"
//                                             src={facebookSignin}
//                                         />
//                                         <a
//                                             // href="https://www.professionaleditingtool.com/api/auth/facebook"
//                                             // href="https://api.mypoet360.com/api/auth/facebook"
//                                             className="googlefblink"
//                                         >Sign up with <strong>Facebook</strong></a>

//                                     </Button>
//                                 </div>
//                             </>
//                         } */}
//               <div className="text-center mt-2">
//                 <Link
//                   to="/privacypolicy"
//                   target={"_blank"}
//                   className="privacyLink"
//                 >
//                   Term of use. Privacy policy
//                 </Link>
//               </div>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default withRouter(SignUp);

// import React, { useState, useEffect } from "react";
// import Loader from "../utils/loader";
// import userService from "../services/userService";
// import { toast, ToastContainer } from "react-toastify";
// import CryptoJS from "crypto-js";
// import { Link, withRouter } from "react-router-dom";
// import "./LoginForm.css";
// import { getHomeCMS } from "../services/adminServices";
// import InputBoxMui from "./ReusableComponents/InputBoxMui";
// import CheckboxMui from "./ReusableComponents/CheckBoxMui";
// import InputBoxPasswordMui from "./ReusableComponents/InputBoxPasswordMui";
// import InputBoxMobile from "./ReusableComponents/InputBoxforMobile";
// import SelectDropdownMui from "./ReusableComponents/SelectDropdownMui";
// import OtpInputBox from "./ReusableComponents/OtpInputBox";
// import { checkOtpStatus, sendOtp, verifyOtp } from "../services/authService";
// import { countries } from "./ReusableComponents/countryList";
// import { getRoles } from "../services/roleServices";
// import { addUserLogs } from "../services/userLogServices";
// import PoetNewlogopen from "../static/loginlogo.png";

// import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
// import Grid from "@mui/material/Unstable_Grid2";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
// import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
// import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";

// // ─── Theme ───────────────────────────────────────────────────────────────────
// const goldTheme = createTheme({
//   palette: {
//     mode: "light",
//     primary: { main: "#C9A84C", light: "#E8C97A", dark: "#9A7A2E" },
//     background: { default: "#FFFDF5", paper: "#FFFFFF" },
//     text: { primary: "#2A1F0A", secondary: "#6B5A2A" },
//   },
//   typography: { fontFamily: "'Cormorant Garamond', 'Georgia', serif" },
//   shape: { borderRadius: 16 },
// });

// // ─── Global styles ────────────────────────────────────────────────────────────
// const injectStyles = () => {
//   if (document.getElementById("sg-gold-styles")) return;
//   const s = document.createElement("style");
//   s.id = "sg-gold-styles";
//   s.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=Lato:wght@300;400;600;700;800&display=swap');
//     *, *::before, *::after { box-sizing: border-box; }

//     /* ── Full screen background ── */
//     .sg-wrap {
//       min-height: 100vh;
//       width: 100%;
//       display: flex;
//       position: relative;
//       overflow-x: hidden;
//       background:
//         radial-gradient(ellipse at 15% 40%, rgba(201,168,76,0.16) 0%, transparent 55%),
//         radial-gradient(ellipse at 85% 15%, rgba(232,201,122,0.13) 0%, transparent 50%),
//         radial-gradient(ellipse at 65% 85%, rgba(201,168,76,0.10) 0%, transparent 50%),
//         linear-gradient(135deg, #FFFDF5 0%, #FFF8E1 45%, #FFFDE7 75%, #F9F3D9 100%);
//     }
//     .sg-wrap::before {
//       content: '';
//       position: fixed; inset: 0;
//       background-image: repeating-linear-gradient(-45deg, rgba(201,168,76,0.025) 0px, rgba(201,168,76,0.025) 1px, transparent 1px, transparent 44px);
//       pointer-events: none; z-index: 0;
//     }

//     /* ── Orbs ── */
//     .sg-orb {
//       position: fixed; border-radius: 50%; pointer-events: none; z-index: 0;
//       animation: orbFloat ease-in-out infinite;
//     }
//     @keyframes orbFloat { 0%,100%{transform:translateY(0) scale(1)} 50%{transform:translateY(-20px) scale(1.04)} }

//     /* ── Particles ── */
//     .sg-particle {
//       position: fixed; border-radius: 50%; background:#C9A84C;
//       pointer-events: none; z-index: 0;
//       animation: particleTwinkle linear infinite;
//     }
//     @keyframes particleTwinkle { 0%,100%{opacity:.12;transform:scale(1)} 50%{opacity:.6;transform:scale(1.6)} }

//     /* ── Left logo container ── */
//     .sg-left-logo {
//       position: fixed;
//       left: 40px;
//       top: 30px;
//       z-index: 10;
//     }

//     /* ── Right container for card ── */
//     .sg-right-container {
//       position: relative;
//       z-index: 2;
//       width: 100%;
//       display: flex;
//       justify-content: flex-end;
//       align-items: flex-start;
//       padding-right: 5%;
//       padding-top: 30px;
//       min-height: 100vh;
//     }

//     /* ── Card - NON-SCROLLABLE, expands with content ── */
//     .sg-card {
//       position: relative;
//       background: rgba(255,255,255,0.94);
//       backdrop-filter: blur(28px);
//       border-radius: 28px;
//       border: 1px solid rgba(201,168,76,0.28);
//       box-shadow:
//         0 2px 4px rgba(201,168,76,0.04),
//         0 10px 28px rgba(201,168,76,0.11),
//         0 28px 56px rgba(201,168,76,0.09),
//         0 56px 96px rgba(0,0,0,0.055),
//         inset 0 1px 0 rgba(255,255,255,0.95),
//         inset 0 -1px 0 rgba(201,168,76,0.08);
//       padding: 32px 40px;
//       width: 100%;
//       max-width: 480px;
//       margin-right: 0;
//       animation: cardIn 0.85s cubic-bezier(0.34,1.56,0.64,1) both;
//       transform-style: preserve-3d;
//       transition: transform 0.4s ease, box-shadow 0.4s ease;
//       height: auto; /* Auto height based on content */
//       overflow: visible; /* No scrollbar */
//     }
//     .sg-card:hover {
//       transform: translateY(-5px) rotateX(1deg);
//       box-shadow:
//         0 6px 10px rgba(201,168,76,0.06),
//         0 18px 44px rgba(201,168,76,0.17),
//         0 44px 72px rgba(201,168,76,0.12),
//         0 70px 110px rgba(0,0,0,0.07),
//         inset 0 1px 0 rgba(255,255,255,1),
//         inset 0 -1px 0 rgba(201,168,76,0.12);
//     }
//     @keyframes cardIn {
//       0% { opacity:0; transform:translateY(64px) rotateX(12deg) scale(0.94); }
//       100% { opacity:1; transform:translateY(0) rotateX(0deg) scale(1); }
//     }
//     /* Gold shimmer line on top of card */
//     .sg-card::before {
//       content:''; position:absolute;
//       top:0; left:12%; right:12%; height:2px;
//       background: linear-gradient(90deg, transparent, rgba(201,168,76,0.75), rgba(232,201,122,1), rgba(201,168,76,0.75), transparent);
//       border-radius: 0 0 2px 2px;
//     }

//     /* Removed scrollable class - card content flows naturally */

//     /* ── Section labels ── */
//     .sg-section-label {
//       font-family: 'Lato', sans-serif;
//       font-weight: 700;
//       font-size: 0.7rem;
//       letter-spacing: 0.14em;
//       text-transform: uppercase;
//       color: #9A7A2E;
//       margin-bottom: 8px;
//       display: flex;
//       align-items: center;
//       gap: 8px;
//     }
//     .sg-section-label::after {
//       content:''; flex:1; height:1px;
//       background: rgba(201,168,76,0.25); border-radius:1px;
//     }

//     /* ── Reduced field spacing ── */
//     .sg-field { margin-bottom: 12px; width: 100%; }

//     /* ── Org box - more compact ── */
//     .sg-org-box {
//       padding: 14px 14px 4px;
//       border-radius: 16px;
//       background: rgba(201,168,76,0.04);
//       border: 1px dashed rgba(201,168,76,0.32);
//       margin-bottom: 12px;
//     }

//     /* ── Mobile row ── */
//     .sg-mobile-row {
//       display: flex;
//       gap: 10px;
//       align-items: flex-start;
//       width: 100%;
//     }
//     .sg-mobile-row > div:first-child { flex: 1; min-width: 0; }

//     /* ── Verify btn ── */
//     .sg-verify-btn {
//       padding: 12px 18px;
//       border-radius: 12px;
//       border: 1.5px solid rgba(201,168,76,0.6);
//       background: rgba(201,168,76,0.06);
//       cursor: pointer;
//       font-family: 'Lato', sans-serif;
//       font-weight: 700;
//       font-size: 0.8rem;
//       letter-spacing: 0.06em;
//       color: #8B6914;
//       white-space: nowrap;
//       flex-shrink: 0;
//       align-self: flex-start;
//       margin-top: 2px;
//       transition: all 0.25s ease;
//     }
//     .sg-verify-btn:hover:not(:disabled) {
//       background: rgba(201,168,76,0.14);
//       border-color: rgba(201,168,76,0.9);
//       transform: translateY(-1px);
//       box-shadow: 0 4px 14px rgba(201,168,76,0.22);
//     }
//     .sg-verify-btn:disabled { opacity: 0.38; cursor: not-allowed; }

//     /* ── Submit btn ── */
//     .sg-submit-btn {
//       width: 100%;
//       padding: 14px 22px;
//       border-radius: 14px; border: none; cursor: pointer;
//       font-family: 'Lato', sans-serif;
//       font-weight: 800; font-size: 0.9rem;
//       letter-spacing: 0.12em; text-transform: uppercase;
//       position: relative; overflow: hidden;
//       background: linear-gradient(135deg, #B8860B 0%, #C9A84C 30%, #E8C97A 50%, #C9A84C 70%, #9A7A2E 100%);
//       background-size: 200% 200%;
//       color: #2A1F0A;
//       box-shadow: 0 4px 16px rgba(201,168,76,0.42), 0 8px 28px rgba(201,168,76,0.22), inset 0 1px 0 rgba(255,255,255,0.45);
//       transition: all 0.3s ease;
//       animation: btnShimmer 3.5s ease infinite;
//     }
//     @keyframes btnShimmer { 0%{background-position:0% 0%} 50%{background-position:100% 100%} 100%{background-position:0% 0%} }
//     .sg-submit-btn:hover:not(:disabled) {
//       transform: translateY(-2px);
//       box-shadow: 0 8px 26px rgba(201,168,76,0.58), 0 16px 40px rgba(201,168,76,0.3), inset 0 1px 0 rgba(255,255,255,0.55);
//     }
//     .sg-submit-btn:active:not(:disabled) { transform: translateY(0); }
//     .sg-submit-btn:disabled {
//       background: linear-gradient(135deg, #D4C4A0, #E8DFC8);
//       color: #9A8E7A; cursor: not-allowed; box-shadow: none; animation: none;
//     }

//     /* ── Resend ── */
//     .sg-resend-btn {
//       background: transparent; border: none;
//       color: #C9A84C; font-family: 'Lato', sans-serif;
//       font-weight: 700; font-size: 0.8rem;
//       text-decoration: underline; cursor: pointer;
//       padding: 0; transition: color 0.2s;
//     }
//     .sg-resend-btn:hover { color: #9A7A2E; }
//     .sg-resend-btn:disabled { color: rgba(201,168,76,0.35); cursor: not-allowed; }

//     /* ── Verified pill ── */
//     .sg-verified {
//       display: flex; align-items: center; gap: 8px;
//       padding: 8px 14px; border-radius: 50px;
//       background: rgba(107,138,58,0.09);
//       border: 1px solid rgba(107,138,58,0.3);
//       margin-bottom: 10px;
//     }
//     .sg-verified span { font-family:'Lato',sans-serif; font-weight:700; font-size:0.8rem; color:#4E7A2A; }

//     /* ── Error text ── */
//     .sg-error {
//       font-family: 'Lato', sans-serif; font-size: 0.75rem;
//       color: #C0392B; margin: 2px 0 0 2px;
//     }

//     /* ── Timer ── */
//     .sg-timer { font-family:'Lato',sans-serif; font-weight:700; font-size:0.8rem; color:#C9A84C; }

//     /* ── Links ── */
//     .sg-signin-link { color:#C9A84C !important; font-weight:700 !important; font-family:'Lato',sans-serif !important; text-decoration:none !important; transition:color 0.2s !important; }
//     .sg-signin-link:hover { color:#9A7A2E !important; text-decoration:underline !important; }
//     .sg-privacy-link { color:#8B6914 !important; font-family:'Lato',sans-serif !important; font-size:0.75rem !important; text-decoration:none !important; }
//     .sg-privacy-link:hover { text-decoration:underline !important; color:#C9A84C !important; }

//     /* ── Divider ── */
//     .sg-divider { display:flex; align-items:center; gap:10px; margin:14px 0; }
//     .sg-divider::before, .sg-divider::after { content:''; flex:1; height:1px; background:rgba(201,168,76,0.28); }
//     .sg-divider span { font-family:'Lato',sans-serif; font-size:0.7rem; letter-spacing:0.12em; color:#C9A84C; }

//     /* ── MUI input overrides ── */
//     .sg-wrap .MuiFormControl-root { width: 100% !important; }
//     .sg-wrap .MuiInputBase-root { border-radius:10px !important; background: rgba(255,253,245,0.6) !important; }
//     .sg-wrap .MuiOutlinedInput-notchedOutline { border-color:rgba(201,168,76,0.3) !important; }
//     .sg-wrap .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline { border-color:rgba(201,168,76,0.65) !important; }
//     .sg-wrap .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline { border-color:#C9A84C !important; border-width:2px !important; box-shadow:0 0 0 4px rgba(201,168,76,0.1); }
//     .sg-wrap .MuiInputLabel-root { color:#8B6914 !important; font-family:'Lato',sans-serif !important; font-size:0.85rem !important; }
//     .sg-wrap .MuiInputLabel-root.Mui-focused { color:#C9A84C !important; }
//     .sg-wrap .MuiInputBase-input { font-family:'Lato',sans-serif !important; color:#2A1F0A !important; font-size:0.88rem !important; }
//     .sg-wrap .MuiSelect-select { font-family:'Lato',sans-serif !important; }
//     .sg-wrap .MuiCheckbox-root.Mui-checked { color:#C9A84C !important; }
//     .sg-wrap .MuiCheckbox-root { color:rgba(201,168,76,0.45) !important; }
//     .sg-wrap .MuiFormControlLabel-label { font-family:'Lato',sans-serif !important; font-size:0.8rem !important; color:#6B5A2A !important; }

//     /* OTP boxes */
//     .sg-wrap input[type="tel"] {
//       border:2px solid rgba(201,168,76,0.38) !important; border-radius:10px !important;
//       background:rgba(255,253,245,0.85) !important; color:#2A1F0A !important;
//       font-family:'Cormorant Garamond',serif !important; font-size:1.2rem !important;
//       font-weight:700 !important; transition:all 0.22s ease !important;
//     }
//     .sg-wrap input[type="tel"]:focus {
//       border-color:#C9A84C !important; box-shadow:0 0 0 3px rgba(201,168,76,0.16) !important; outline:none !important;
//     }

//     /* Responsive adjustments */
//     @media (max-width: 768px) {
//       .sg-left-logo {
//         position: relative;
//         left: 20px;
//         top: 20px;
//         margin-bottom: 10px;
//       }
//       .sg-right-container {
//         justify-content: center;
//         padding-right: 20px;
//         padding-left: 20px;
//         padding-top: 10px;
//         align-items: center;
//       }
//       .sg-card {
//         max-width: 100%;
//         margin: 0 auto;
//         padding: 24px 20px;
//       }
//     }

//     /* Remove any scrollbar styles */
//     .sg-card::-webkit-scrollbar {
//       display: none;
//     }
//   `;
//   document.head.appendChild(s);
// };

// // ─── Component ────────────────────────────────────────────────────────────────
// function SignUp({ history }) {
//   useEffect(() => {
//     injectStyles();
//   }, []);

//   const [email, setEmail] = useState("");
//   const [values, setValues] = useState({});
//   const [username, setUserName] = useState("");
//   const [organizationName, setOrganizationName] = useState("");
//   const [organizationId, setOrganizationId] = useState("");
//   const [password, setPassword] = useState("");
//   const [isTermsAccepted, setAcceptTerms] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState("");
//   const [disable, setdisable] = useState(true);
//   const [roleList] = useState([
//     { value: "Individual", name: "Individual" },
//     { value: "Organization", name: "Organization" },
//   ]);
//   const [role, setRole] = useState("");
//   const [userRoleList, setUserRoleList] = useState([]);
//   const [userRole, setUserRole] = useState("");
//   const [countryList, setCountryList] = useState([]);
//   const [otpValue, setOtpValue] = useState("");
//   const [countryCode, setCountryCode] = useState("");
//   const [mobileNo, setMobileNo] = useState("");
//   const [isOtpShown, setIsOtpShown] = useState(false);
//   const [isOtpVerify, setIsOtpVerify] = useState(false);
//   const [verifyDisable, setVerifyDisable] = useState(true);
//   const [timer, setTimer] = useState(0);
//   const [isResendCodeDisable, setisResendCodeDisable] = useState(true);
//   const [isResendButton, setIsResendButton] = useState(false);
//   const [isPasswordValid, setIsPasswordValid] = useState(true);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [showRoles, setShowRoles] = useState(false);
//   const [otpErrorMsg, setErrorMsg] = useState(null);

//   const selectedCountry = countries.find(
//     (c) => c.phone === countryCode.slice(1),
//   );
//   const countryName = selectedCountry ? selectedCountry.label : "";

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await getHomeCMS();
//       } catch {}
//     })();
//   }, []);

//   async function handleRegisterSubmit() {
//     if (!username) {
//       toast.warn("Please enter the username");
//       return;
//     }
//     if (!email) {
//       toast.warn("Please enter the email");
//       return;
//     }
//     if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
//       toast.warn("Please enter a valid email address.");
//       return;
//     }
//     if (role === "Organization") {
//       if (!organizationName) {
//         toast.warn("Please enter Organization Name");
//         return;
//       }
//       if (!organizationId) {
//         toast.warn("Please enter Organization ID");
//         return;
//       }
//       if (!userRole) {
//         toast.warn("Please select User Role");
//         return;
//       }
//     }
//     if (!password) {
//       toast.warn("Please enter the password");
//       return;
//     }
//     if (!mobileNo) {
//       toast.warn("Please enter the Mobile Number");
//       return;
//     }
//     if (!isTermsAccepted) {
//       toast.warn("Please accept the Terms & Conditions");
//       return;
//     }
//     if (password.length < 6) {
//       toast.warn("Password must contain at least 6 characters");
//       return;
//     }

//     const hashedPassword = CryptoJS.SHA256(password).toString();
//     const user = {
//       username,
//       email,
//       password: hashedPassword,
//       phone: countryCode + mobileNo,
//       referedEmail:
//         localStorage.getItem("referedEmail") !== "undefined"
//           ? localStorage.getItem("referedEmail")
//           : "",
//       Role: role,
//       organizationName: role === "Organization" ? organizationName : "",
//       organizationId: role === "Organization" ? organizationId : "",
//       userRole: role === "Organization" ? userRole : "",
//       country: countryName,
//     };
//     setLoading(true);
//     const result = await userService.register(user);
//     setLoading(false);
//     if (result.status !== 201) {
//       if (result?.Role === "Individual") {
//         toast.info(result.message);
//         history.push({
//           pathname: `/afterRegistration`,
//           state: { detail: user },
//         });
//       } else toast.warn(result.message);
//     } else {
//       localStorage.removeItem("referedEmail");
//       localStorage.removeItem("accountType");
//       toast.info(result.message);
//       if (!result?.users)
//         history.push({
//           pathname: `/afterRegistration`,
//           state: { detail: user },
//         });
//       try {
//         const logData = {
//           userId: result?.data?._id,
//           organizationId: result?.data?.organizationId,
//           actionType: "signup",
//         };
//         const addLogs = await addUserLogs(logData);
//         if (addLogs.status !== 200) toast.error(addLogs.message);
//       } catch {
//         toast.error("Internal server error");
//       }
//     }
//   }

//   function handleAcceptTerms(e) {
//     setAcceptTerms(e.target.checked);
//   }

//   function handlePassword(e) {
//     const pass = e.target.value;
//     if (pass.length > 0) {
//       if (pass.length <= 7) {
//         setErrors("Minimum 8 characters required");
//         setIsPasswordValid(false);
//       } else if (!/[A-Z]/.test(pass)) {
//         setErrors("At least 1 uppercase letter required");
//         setIsPasswordValid(false);
//       } else if (!/[0-9]/.test(pass)) {
//         setErrors("At least 1 number required");
//         setIsPasswordValid(false);
//       } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(pass)) {
//         setErrors("At least 1 special character required");
//         setIsPasswordValid(false);
//       } else {
//         setErrors("");
//         setIsPasswordValid(true);
//         setPassword(pass);
//       }
//     } else {
//       setErrors("");
//       setIsPasswordValid(true);
//     }
//   }

//   const handleRole = (e) => setRole(e.target.value);
//   const handleUserRole = (e) => setUserRole(e.target.value);
//   const handleCountry = (event, value) => {
//     if (value.phone !== "" && mobileNo !== "") {
//       setVerifyDisable(false);
//       setIsOtpShown(false);
//       setIsResendButton(false);
//     } else setVerifyDisable(true);
//     setCountryCode(`+${value.phone}`);
//   };

//   const handleNumber = (e) => {
//     const map = {
//       "+1": 10,
//       "+91": 10,
//       "+86": 11,
//       "+44": 10,
//       "+61": 9,
//       "+49": 11,
//       "+33": 9,
//       "+81": 10,
//       "+55": 11,
//       "+7": 10,
//       "+82": 10,
//       "+34": 9,
//       "+39": 10,
//       "+62": 10,
//       "+31": 9,
//       "+971": 9,
//       "+966": 9,
//       "+65": 8,
//       "+60": 10,
//       "+27": 10,
//       "+92": 10,
//       "+880": 11,
//       "+234": 10,
//       "+254": 10,
//       "+63": 10,
//       "+66": 9,
//       "+48": 9,
//       "+351": 9,
//       "+46": 10,
//       "+45": 8,
//       "+358": 9,
//       "+47": 8,
//       "+41": 9,
//       "+43": 13,
//       "+353": 9,
//       "+420": 9,
//       "+36": 9,
//       "+40": 10,
//       "+380": 9,
//       "+375": 9,
//       "+994": 9,
//       "+995": 9,
//       "+374": 8,
//       "+998": 9,
//       "+992": 9,
//       "+996": 9,
//       "+993": 9,
//       "+93": 9,
//       "+98": 10,
//       "+964": 10,
//       "+962": 9,
//       "+961": 8,
//       "+972": 9,
//       "+20": 10,
//       "+212": 9,
//       "+216": 8,
//       "+213": 9,
//       "+218": 10,
//       "+249": 10,
//       "+251": 10,
//       "+255": 10,
//       "+256": 10,
//       "+250": 10,
//       "+237": 9,
//       "+233": 10,
//       "+221": 9,
//       "+57": 10,
//       "+56": 9,
//       "+51": 9,
//       "+58": 10,
//       "+593": 9,
//       "+507": 8,
//       "+506": 8,
//       "+502": 8,
//       "+503": 8,
//       "+504": 8,
//       "+505": 8,
//       "+52": 10,
//       "+54": 10,
//       "+598": 8,
//       "+591": 8,
//       "+595": 9,
//       "+64": 9,
//       "+84": 10,
//       "+95": 9,
//       "+855": 8,
//       "+856": 8,
//       "+94": 10,
//       "+977": 10,
//       "+975": 8,
//       "+960": 7,
//     };
//     const max = map[countryCode] || 10;
//     if (e.length > max) return;
//     setErrorMessage(
//       e.length > 0 && e.length < max ? `Enter a ${max}-digit phone number` : "",
//     );
//     const valid =
//       (e.length === 11 && countryCode === "+86") ||
//       (e.length === max && countryCode !== "+86" && countryCode !== "");
//     if (valid) {
//       setVerifyDisable(false);
//       setIsOtpShown(false);
//       setIsResendButton(false);
//     } else setVerifyDisable(true);
//     setMobileNo(e);
//   };

//   const handleOTP = async (e) => {
//     setOtpValue(e);
//     if (e.length === 6) {
//       setLoading(true);
//       const res = await verifyOtp({ phone: countryCode + mobileNo, otp: e });
//       setLoading(false);
//       if (res.status === 200) {
//         setIsOtpShown(false);
//         setIsOtpVerify(true);
//         setVerifyDisable(true);
//         setdisable(false);
//         setisResendCodeDisable(false);
//         setIsResendButton(false);
//       } else {
//         setIsOtpVerify(false);
//         setIsOtpShown(true);
//         setisResendCodeDisable(true);
//         setIsResendButton(true);
//         setErrorMsg(res.message);
//       }
//     }
//   };

//   const handleVerify = async () => {
//     setOtpValue("");
//     setTimer(60);
//     setIsOtpVerify(false);
//     if (!role) {
//       toast.warn("Please select a role.");
//       return;
//     }
//     if (!isPasswordValid) {
//       toast.warn("Please enter a valid password.");
//       return;
//     }
//     if (!username) {
//       toast.warn("Please enter the username");
//       return;
//     }
//     if (!email) {
//       toast.warn("Please enter the email");
//       return;
//     }
//     if (role === "Organization") {
//       if (!organizationName) {
//         toast.warn("Please enter Organization Name");
//         return;
//       }
//       if (!organizationId) {
//         toast.warn("Please enter Organization ID");
//         return;
//       }
//       if (!userRole) {
//         toast.warn("Please select User Role");
//         return;
//       }
//     }
//     if (!password) {
//       toast.warn("Please enter the password");
//       return;
//     }
//     if (!mobileNo) {
//       toast.warn("Please enter the Mobile Number");
//       return;
//     }
//     const payload = { phone: countryCode + mobileNo };
//     const statusRes = await checkOtpStatus(payload);
//     if (statusRes.status === 200) {
//       const d = statusRes.data;
//       if (d.lockUntil && new Date(d.lockUntil) > new Date()) {
//         toast.warn(
//           `Locked due to failed attempts. Try again after ${new Date(d.lockUntil).toLocaleString()}.`,
//         );
//         return;
//       }
//     }
//     const sentRes = await sendOtp(payload);
//     if (sentRes.status === 200) {
//       toast.success("OTP sent successfully");
//       setIsResendButton(true);
//       setIsOtpShown(true);
//       setVerifyDisable(true);
//     } else toast.warn("Invalid Phone Number");
//   };

//   useEffect(() => {
//     const t = setTimeout(() => {
//       if (timer > 0) setTimer(timer - 1);
//     }, 1000);
//     if (timer === 0) {
//       setisResendCodeDisable(false);
//       setIsOtpShown(false);
//     } else setisResendCodeDisable(true);
//     return () => clearTimeout(t);
//   }, [timer]);

//   const formatTime = (t) =>
//     `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;

//   useEffect(() => {
//     setCountryList(countries.map((c) => ({ name: c.label, value: c.label })));
//   }, []);

//   useEffect(() => {
//     if (!organizationId || role !== "Organization") {
//       setShowRoles(false);
//       return;
//     }
//     const t = setTimeout(async () => {
//       try {
//         setLoading(true);
//         const res = await getRoles({ organizationId });
//         setUserRoleList(res?.userRoleList || []);
//         setShowRoles(true);
//       } catch {
//       } finally {
//         setLoading(false);
//       }
//     }, 2000);
//     return () => clearTimeout(t);
//   }, [organizationId]);

//   const particles = [
//     { w: 5, top: "8%", left: "6%", dur: "4.2s", del: "0s" },
//     { w: 4, top: "22%", left: "88%", dur: "6.1s", del: "1.1s" },
//     { w: 6, top: "58%", left: "4%", dur: "5.3s", del: "2.0s" },
//     { w: 3, top: "82%", left: "78%", dur: "7.0s", del: "0.6s" },
//     { w: 5, top: "44%", left: "94%", dur: "4.7s", del: "1.7s" },
//     { w: 4, top: "91%", left: "28%", dur: "5.8s", del: "3.1s" },
//     { w: 3, top: "14%", left: "52%", dur: "6.4s", del: "2.4s" },
//     { w: 5, top: "68%", left: "45%", dur: "4.0s", del: "0.9s" },
//   ];

//   return (
//     <ThemeProvider theme={goldTheme}>
//       <div className="sg-wrap">
//         <ToastContainer />
//         <Loader loading={loading} />

//         {/* Floating orbs */}
//         <div
//           className="sg-orb"
//           style={{
//             width: 320,
//             height: 320,
//             top: -90,
//             left: -110,
//             background:
//               "radial-gradient(circle at 30% 30%, rgba(232,201,122,0.28), rgba(201,168,76,0.06))",
//             border: "1px solid rgba(201,168,76,0.14)",
//             animationDuration: "9s",
//             animationDelay: "0s",
//           }}
//         />
//         <div
//           className="sg-orb"
//           style={{
//             width: 220,
//             height: 220,
//             top: "12%",
//             right: -60,
//             background:
//               "radial-gradient(circle at 40% 40%, rgba(232,201,122,0.2), rgba(201,168,76,0.05))",
//             border: "1px solid rgba(201,168,76,0.12)",
//             animationDuration: "7s",
//             animationDelay: "2s",
//           }}
//         />
//         <div
//           className="sg-orb"
//           style={{
//             width: 160,
//             height: 160,
//             bottom: "6%",
//             left: "4%",
//             background:
//               "radial-gradient(circle at 40% 40%, rgba(232,201,122,0.18), rgba(201,168,76,0.04))",
//             border: "1px solid rgba(201,168,76,0.12)",
//             animationDuration: "8s",
//             animationDelay: "4s",
//           }}
//         />
//         <div
//           className="sg-orb"
//           style={{
//             width: 110,
//             height: 110,
//             bottom: "18%",
//             right: "6%",
//             background:
//               "radial-gradient(circle at 40% 40%, rgba(232,201,122,0.16), rgba(201,168,76,0.04))",
//             border: "1px solid rgba(201,168,76,0.1)",
//             animationDuration: "6s",
//             animationDelay: "1.5s",
//           }}
//         />

//         {/* Particles */}
//         {particles.map((p, i) => (
//           <div
//             key={i}
//             className="sg-particle"
//             style={{
//               width: p.w,
//               height: p.w,
//               top: p.top,
//               left: p.left,
//               animationDuration: p.dur,
//               animationDelay: p.del,
//             }}
//           />
//         ))}

//         {/* ── Logo: left side (fixed position) ── */}
//         <div className="sg-left-logo">
//           <Link to="/">
//             <img
//               src={PoetNewlogopen}
//               alt="Logo"
//               style={{
//                height: 150,
//                 width: "auto",
//                 objectFit: "contain",
//                 filter: "drop-shadow(0 2px 10px rgba(201,168,76,0.32))",
//               }}
//             />
//           </Link>
//         </div>

//         {/* ── Card: right side, positioned at top, NON-SCROLLABLE ── */}
//         <div className="sg-right-container">
//           <div className="sg-card">
//             {/* Card header */}
//             <Box sx={{ mb: 2.5, textAlign: "center" }}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: 1,
//                   mb: 0.5,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     width: 32,
//                     height: 30,
//                     borderRadius: "50%",
//                     background:
//                       "linear-gradient(135deg,rgba(201,168,76,0.2),rgba(232,201,122,0.4))",
//                     border: "1px solid rgba(201,168,76,0.4)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <AutoAwesomeRoundedIcon
//                     sx={{ color: "#C9A84C", fontSize: 16 }}
//                   />
//                 </Box>
//                 <Typography
//                   sx={{
//                     fontFamily: "'Cormorant Garamond',serif",
//                     fontWeight: 700,
//                     fontSize: "1.7rem",
//                     color: "#2A1F0A",
//                     lineHeight: 0.5,
//                   }}
//                 >
//                   Create Account
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Role */}

//             <div className="sg-field">
//               <SelectDropdownMui
//                 optionsList={roleList}
//                 selectLabel={"Select Role"}
//                 onChange={handleRole}
//                 value={role}
//               />
//             </div>

//             {/* Organization fields */}
//             {role === "Organization" && (
//               <div className="sg-org-box">
//                 <div className="sg-field">
//                   <InputBoxMui
//                     fullWidth
//                     type="text"
//                     label="Organization Name*"
//                     onChange={(e) => setOrganizationName(e.target.value)}
//                   />
//                 </div>
//                 <div className="sg-field">
//                   <InputBoxMui
//                     fullWidth
//                     type="text"
//                     label="Organization ID*"
//                     onChange={(e) => {
//                       setOrganizationId(e.target.value);
//                       setUserRole("");
//                       setShowRoles(false);
//                     }}
//                   />
//                 </div>
//                 {organizationId && showRoles && (
//                   <div className="sg-field">
//                     <SelectDropdownMui
//                       optionsList={userRoleList}
//                       selectLabel={"User Role"}
//                       onChange={handleUserRole}
//                       value={userRole}
//                     />
//                   </div>
//                 )}
//               </div>
//             )}

//             <div className="sg-field">
//               <InputBoxMui
//                 fullWidth
//                 type="text"
//                 label="Username*"
//                 onChange={(e) => setUserName(e.target.value)}
//               />
//             </div>

//             <div className="sg-field">
//               <InputBoxMui
//                 fullWidth
//                 type="email"
//                 label="Email Address*"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//             </div>

//             <div className="sg-field" style={{ marginBottom: errors ? 2 : 10 }}>
//               <InputBoxPasswordMui
//                 fullWidth
//                 label="Password*"
//                 type={values.showPassword ? "text" : "password"}
//                 value={values.password}
//                 onChange={(e) => handlePassword(e)}
//               />
//             </div>
//             {errors && (
//               <p className="sg-error" style={{ marginBottom: 8 }}>
//                 ⚠ {errors}
//               </p>
//             )}

//             {/* Mobile + Verify */}
//             <div className="sg-field">
//               <div className="sg-mobile-row">
//                 <div>
//                   <InputBoxMobile
//                     onChange={(e) => handleNumber(e)}
//                     handleCountryCode={handleCountry}
//                     value={mobileNo}
//                   />
//                 </div>
//                 <button
//                   className="sg-verify-btn"
//                   disabled={verifyDisable}
//                   onClick={handleVerify}
//                 >
//                   Verify
//                 </button>
//               </div>
//               {errorMessage && <p className="sg-error">{errorMessage}</p>}
//             </div>

//             {/* OTP */}
//             {isOtpShown && (
//               <div className="sg-field" style={{ textAlign: "center" }}>
//                 <Typography
//                   sx={{
//                     fontFamily: "'Lato',sans-serif",
//                     fontSize: "0.78rem",
//                     color: "#8B6914",
//                     mb: 1,
//                   }}
//                 >
//                   Enter the 6-digit code sent to your mobile
//                 </Typography>
//                 <OtpInputBox value={otpValue} onChange={(e) => handleOTP(e)} />
//                 {!isOtpVerify && otpValue?.length === 6 && otpErrorMsg && (
//                   <p
//                     className="sg-error"
//                     style={{ textAlign: "center", marginTop: 4 }}
//                   >
//                     {otpErrorMsg}
//                   </p>
//                 )}
//               </div>
//             )}

//             {/* Resend + timer */}
//             {(isResendButton || isOtpShown) && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: 8,
//                 }}
//               >
//                 {isResendButton && (
//                   <button
//                     className="sg-resend-btn"
//                     onClick={handleVerify}
//                     disabled={isResendCodeDisable}
//                   >
//                     Resend Code
//                   </button>
//                 )}
//                 {isOtpShown && (
//                   <span className="sg-timer">{formatTime(timer)}</span>
//                 )}
//               </div>
//             )}

//             {/* Verified badge */}
//             {isOtpVerify && (
//               <div className="sg-verified">
//                 <VerifiedUserRoundedIcon
//                   style={{ color: "#4E7A2A", fontSize: 18 }}
//                 />
//                 <span>Phone Number Verified</span>
//               </div>
//             )}

//             {/* Terms */}
//             <div style={{ marginBottom: 1.5 }}>
//               <CheckboxMui
//                 label="I agree with terms and conditions"
//                 isChecked={isTermsAccepted}
//                 onChange={(e) => handleAcceptTerms(e)}
//               />
//             </div>

//             {/* Submit */}
//             <button
//               className="sg-submit-btn"
//               disabled={disable}
//               onClick={handleRegisterSubmit}
//             >
//               ✦ &nbsp; Create My Account
//             </button>

//             {/* Footer */}
//             <Box sx={{ textAlign: "center", mt: 2 }}>
//               <Typography
//                 sx={{
//                   fontFamily: "'Lato',sans-serif",
//                   fontSize: "0.82rem",
//                   color: "#6B5A2A",
//                 }}
//               >
//                 Already have an account?{" "}
//                 <Link to="/login" className="sg-signin-link">
//                   Sign In
//                 </Link>
//               </Typography>
//             </Box>
//             <Box sx={{ textAlign: "center", mt: 0.5 }}>
//               <Link
//                 to="/privacypolicy"
//                 target="_blank"
//                 className="sg-privacy-link"
//               >
//                 Terms of Use · Privacy Policy
//               </Link>
//             </Box>
//           </div>
//         </div>
//       </div>
//     </ThemeProvider>
//   );
// }

// export default withRouter(SignUp);

import React, { useState, useEffect } from "react";
import Loader from "../utils/loader";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import userService from "../services/userService";
import { toast, ToastContainer } from "react-toastify";
import CryptoJS from "crypto-js";
import Group244 from "../static/Group244.png";
import Group5702x from "../static/Group5702x.png";
import { Link, withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import "./LoginForm.css";
import { getHomeCMS } from "../services/adminServices";
import {
  Card,
  InputGroup,
  FormControl,
  Form,
  Button,
  ButtonGroup,
  Carousel,
} from "react-bootstrap";
import loginBackground from "../static/loginBackground.png";
import PetLogo from "../static/POET_Logo_Mid.png";
import googleSignin from "../static/signup_login/googleSignin.png";
import facebookSignin from "../static/signup_login/facebookSignin.png";
import tick from "../static/signup_login/Check.png";
import Login1 from "../static/signupBg.png";
import InputBoxMui from "./ReusableComponents/InputBoxMui";
import CheckboxMui from "./ReusableComponents/CheckBoxMui";
import InputBoxPasswordMui from "./ReusableComponents/InputBoxPasswordMui";
import InputBoxMobile from "./ReusableComponents/InputBoxforMobile";
import SelectDropdownMui from "./ReusableComponents/SelectDropdownMui";
import OtpInputBox from "./ReusableComponents/OtpInputBox";
import { checkOtpStatus, sendOtp, verifyOtp } from "../services/authService";
import { countries } from "./ReusableComponents/countryList";
import { getRoles } from "../services/roleServices";
import { addUserLogs } from "../services/userLogServices";
import PoetNewlogopen from "../static/loginlogo.png";

// MUI Grid v2 import
import Grid from "@mui/material/Unstable_Grid2";

// Animation keyframes and styles
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  dense: {
    marginTop: 19,
  },
}));

// Custom CSS for white-blue theme and animations
const customStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

  * {
    font-family: 'Poppins', sans-serif;
  }
input {
  color: #000000 !important;
}
  /* Floating Animation */
  @keyframes float {
    0% {
      transform: translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateY(-15px) rotate(2deg);
    }
    100% {
      transform: translateY(0px) rotate(0deg);
    }
  }

  /* Jumping Animation */
  @keyframes jump {
    0%, 100% {
      transform: translateY(0) scale(1);
    }
    50% {
      transform: translateY(-20px) scale(1.05);
    }
  }

  /* Rotation Animation */
  @keyframes rotate {
    from {
      transform: rotate(0deg) scale(1);
    }
    to {
      transform: rotate(360deg) scale(1.05);
    }
  }

  /* Pulse Animation */
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.05);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0.8;
    }
  }

  /* Slide In Animation */
  @keyframes slideIn {
    from {
      transform: translateX(-50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  /* Wave Animation */
  @keyframes wave {
    0% {
      transform: translateX(0) translateY(0);
    }
    25% {
      transform: translateX(10px) translateY(-10px);
    }
    50% {
      transform: translateX(0) translateY(0);
    }
    75% {
      transform: translateX(-10px) translateY(10px);
    }
    100% {
      transform: translateX(0) translateY(0);
    }
  }

  /* Background moving gradient - White/Blue theme */
  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  /* Shimmer Effect */
  @keyframes shimmer {
    0% {
      background-position: -100% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  .animated-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
   #f0f5fb,
  #e3f2ff,
  #bbdefb,
  #d5e9f9
    );
    background-size: 400% 400%;
    animation: gradientMove 15s ease infinite;
    z-index: -2;
  }

  .floating-shapes {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden;
  }

  .shape {
    position: absolute;
    background: rgba(33, 150, 243, 0.08);
    border-radius: 50%;
    filter: blur(8px);
  }

  .shape-1 {
    width: 400px;
    height: 400px;
    top: -150px;
    right: -100px;
    animation: float 10s ease-in-out infinite;
    background: radial-gradient(circle, rgba(33,150,243,0.15) 0%, transparent 70%);
  }

  .shape-2 {
    width: 350px;
    height: 350px;
    bottom: -100px;
    left: -100px;
    animation: float 12s ease-in-out infinite reverse;
    background: radial-gradient(circle, rgba(25,118,210,0.12) 0%, transparent 70%);
  }

  .shape-3 {
    width: 200px;
    height: 200px;
    top: 20%;
    left: 15%;
    animation: jump 7s ease-in-out infinite;
    background: radial-gradient(circle, rgba(100,181,246,0.1) 0%, transparent 70%);
    border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
  }

  .shape-4 {
    width: 250px;
    height: 250px;
    bottom: 25%;
    right: 10%;
    animation: rotate 20s linear infinite;
    border: 2px solid rgba(33, 150, 243, 0.1);
    background: transparent;
    border-radius: 40% 60% 60% 40% / 40% 40% 60% 60%;
  }

  .shape-5 {
    width: 150px;
    height: 150px;
    top: 60%;
    left: 20%;
    animation: wave 8s ease-in-out infinite;
    background: rgba(33, 150, 243, 0.07);
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }

  .shape-6 {
    width: 180px;
    height: 180px;
    top: 15%;
    right: 25%;
    animation: float 9s ease-in-out infinite;
    background: rgba(25, 118, 210, 0.06);
    border-radius: 20% 80% 80% 20% / 20% 20% 80% 80%;
  }

  /* Bubbles */
  .bubble {
    position: absolute;
    background: rgba(33, 150, 243, 0.1);
    border-radius: 50%;
    animation: float 6s ease-in-out infinite;
  }

  .bubble-1 {
    width: 60px;
    height: 60px;
    top: 10%;
    left: 10%;
    animation-delay: 0s;
  }

  .bubble-2 {
    width: 40px;
    height: 40px;
    top: 30%;
    right: 15%;
    animation-delay: 1s;
  }

  .bubble-3 {
    width: 80px;
    height: 80px;
    bottom: 20%;
    left: 15%;
    animation-delay: 2s;
  }

  .bubble-4 {
    width: 50px;
    height: 50px;
    bottom: 40%;
    right: 20%;
    animation-delay: 1.5s;
  }

  /* Card Styles - White/Blue theme with 3D effect */
  .signup-card {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(33, 150, 243, 0.2) !important;
    border-radius: 30px !important;
    box-shadow: 
      0 30px 60px rgba(33, 150, 243, 0.15),
      0 10px 30px rgba(0, 0, 0, 0.1),
      inset 0 -5px 15px rgba(33, 150, 243, 0.1) !important;
    animation: slideIn 0.8s ease-out;
    max-width: 500px !important;
    width: 100% !important;
    margin: 10px !important;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    transform-style: preserve-3d;
    perspective: 1000px;
  }

  // .signup-card:hover {
  //   transform: translateY(-10px) rotateX(5deg) rotateY(2deg) scale(1.02);
  //   box-shadow: 
  //     0 50px 80px rgba(33, 150, 243, 0.25),
  //     0 20px 40px rgba(0, 0, 0, 0.15),
  //     inset 0 -5px 20px rgba(33, 150, 243, 0.15) !important;
  // }
  .signup-card:hover {
  transform: translateY(-5px) scale(1.01);
  box-shadow: 
    0 40px 70px rgba(33, 150, 243, 0.18),
    0 15px 35px rgba(0, 0, 0, 0.12) !important;
}

  .mainHeading {
    color: #1a237e !important;
    font-size: 2.2rem !important;
    font-weight: 600 !important;
    text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.2);
    letter-spacing: 1px;
    margin-bottom: 25px !important;
    position: relative;
    display: inline-block;
    animation: pulse 3s ease-in-out infinite;
  }

  .mainHeading::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #2196f3, #64b5f6, #2196f3);
    border-radius: 3px;
    animation: shimmer 2s infinite;
    background-size: 200% 100%;
  }

  /* Input field styles for white-blue theme */
  .MuiInputBase-root {
    color:  #000000 !important;
    background: rgba(255, 255, 255, 0.9) !important;
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
  }

  .MuiInputLabel-root {
    color: #000000 !important;  
    font-weight: 500 !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(38, 157, 255, 0.74) !important;
    border-width: 0.5px !important;
    border-radius: 12px !important;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #259dff !important;
    box-shadow: 0 0 15px rgba(33, 150, 243, 0.3) !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2 !important;
    border-width: 1px !important;
    box-shadow: 0 0 20px rgba(33, 150, 243, 0.4) !important;
  }

  .MuiInputBase-input {
  color: #000000 !important;   /* make text black */
  font-weight: 500 !important; /* optional: slightly stronger */
}

/* For password fields too */
.MuiOutlinedInput-input {
  color: #000000 !important;
}

  /* Button styles with 3D effect */
  .loginBtnVerify, .loginBtnRegister {
    background: linear-gradient(145deg, #2196f3, #1976d2) !important;
    border: none !important;
    border-radius: 12px !important;
    color: white !important;
    font-weight: 600 !important;
    padding: 12px 30px !important;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    position: relative !important;
    overflow: hidden !important;
    box-shadow: 
      0 10px 20px rgba(33, 150, 243, 0.3),
      0 3px 6px rgba(0, 0, 0, 0.1),
      inset 0 -2px 5px rgba(255, 255, 255, 0.3) !important;
    transform-style: preserve-3d;
  }

  .loginBtnVerify:hover, .loginBtnRegister:hover {
    transform: translateY(-5px) scale(1.05) rotateX(5deg);
    box-shadow: 
      0 20px 30px rgba(33, 150, 243, 0.4),
      0 5px 15px rgba(0, 0, 0, 0.2),
      inset 0 -2px 8px rgba(255, 255, 255, 0.4) !important;
  }

  .loginBtnVerify:active, .loginBtnRegister:active {
    transform: translateY(2px) scale(0.98);
    box-shadow: 0 5px 10px rgba(33, 150, 243, 0.2) !important;
  }

  .loginBtnVerify::before, .loginBtnRegister::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s ease;
  }

  .loginBtnVerify:hover::before, .loginBtnRegister:hover::before {
    left: 100%;
  }

  .loginBtnVerify:disabled, .loginBtnRegister:disabled {
    opacity: 0.6;
    transform: none !important;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1) !important;
    background: linear-gradient(145deg, #b0bec5, #90a4ae) !important;
  }

  /* OTP Resend Button */
  .otpresend {
    background: transparent !important;
    border: 2px solid #2196f3 !important;
    color: #1976d2 !important;
    padding: 8px 20px !important;
    border-radius: 25px !important;
    transition: all 0.3s ease !important;
    font-weight: 600 !important;
    box-shadow: 0 5px 15px rgba(33, 150, 243, 0.2) !important;
  }

  .otpresend:hover:not(:disabled) {
    background: linear-gradient(145deg, #2196f3, #1976d2) !important;
    color: white !important;
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 10px 25px rgba(33, 150, 243, 0.3) !important;
  }

  .otpresend:disabled {
    opacity: 0.5;
    border-color: #b0bec5 !important;
    color: #90a4ae !important;
    transform: none !important;
    box-shadow: none !important;
  }

  /* Verified Message */
  .verifyMsg {
    color: #4caf50 !important;
    font-weight: 600 !important;
    animation: pulse 2s ease-in-out infinite;
    background: rgba(76, 175, 80, 0.1);
    padding: 5px 15px;
    border-radius: 20px;
    border: 1px solid #4caf50;
  }

  .tickicon {
    animation: jump 1s ease-in-out;
    width: 24px;
    height: 24px;
  }

  /* Links */
  .privacyLink {
    color: #546e7a !important;
    text-decoration: none !important;
    transition: all 0.3s ease !important;
    font-size: 0.9rem !important;
    font-weight: 500 !important;
    position: relative;
  }

  .privacyLink:hover {
    color: #1976d2 !important;
    transform: translateY(-2px);
  }

  .privacyLink::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, #2196f3, #64b5f6);
    transition: width 0.3s ease;
  }

  .privacyLink:hover::after {
    width: 100%;
  }

  .signinLink {
    color: #1976d2 !important;
    text-decoration: none !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;
    position: relative !important;
    padding: 2px 5px;
  }

  .signinLink:hover {
    color: #0d47a1 !important;
    text-shadow: 0 0 10px rgba(33, 150, 243, 0.3);
    transform: translateX(5px);
  }

  /* Error Messages */
  .errorMsg {
    color: #f44336 !important;
    font-size: 0.85rem !important;
    margin-top: 5px !important;
    animation: pulse 1s ease-in-out !important;
    background: rgba(244, 67, 54, 0.1);
    padding: 5px 10px;
    border-radius: 20px;
    border-left: 3px solid #f44336;
  }

  .text-danger {
    color: #f44336 !important;
    background: rgba(244, 67, 54, 0.1);
    padding: 8px 15px;
    border-radius: 10px;
    margin: 5px 0 !important;
  }

  /* Logo */
  .petLogoContainer {
    position: fixed !important;
    top: 25px !important;
    left: 25px !important;
    z-index: 1000 !important;
  }

  .petLogo {
    max-width: 150px !important;
    filter: drop-shadow(0 10px 15px rgba(33, 150, 243, 0.3)) !important;
    animation: float 6s ease-in-out infinite !important;
    transition: all 0.3s ease !important;
  }

  .petLogo:hover {
    transform: scale(1.1) rotate(5deg);
    filter: drop-shadow(0 15px 20px rgba(33, 150, 243, 0.4)) !important;
  }

  /* Timer text */
  .ml-5 {
    color: #1976d2 !important;
    font-weight: 600 !important;
    background: rgba(33, 150, 243, 0.1);
    padding: 5px 15px;
    border-radius: 25px;
    font-size: 1.1rem;
  }

  /* Checkbox styles */
  .MuiCheckbox-root {
    color: #1976d2 !important;
  }

  .MuiCheckbox-root.Mui-checked {
    color: #2196f3 !important;
    animation: pulse 0.5s ease-in-out;
  }

  .MuiTypography-body1 {
    color: #1a237e !important;
    font-weight: 500 !important;
  }

  /* Select dropdown */
  .MuiSelect-root {
    color: #1a237e !important;
  }

  .MuiMenuItem-root {
    color: #1a237e !important;
  }

  /* OTP Input */
  .otp-input {
    background: white !important;
    border: 2px solid rgba(33, 150, 243, 0.3) !important;
    color: #1a237e !important;
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
    font-size: 1.5rem !important;
    font-weight: 600 !important;
  }

  .otp-input:focus {
    border-color: #2196f3 !important;
    box-shadow: 0 0 20px rgba(33, 150, 243, 0.4) !important;
    transform: scale(1.1) translateY(-3px);
  }

  /* Grid Container */
  .grid-container {
    min-height: 100vh;
    width: 100%;
    padding: 20px;
  }

  /* Responsive adjustments */
  @media (max-width: 600px) {
    .signup-card {
      margin: 10px !important;
      padding: 10px 15px !important;
    }
    
    .mainHeading {
      font-size: 2rem !important;
    }
    
    .petLogo {
      max-width: 100px !important;
    }
  }
`;

function SignUp({ history }) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [values, setValues] = useState("");
  const [username, setUserName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [password, setPassword] = useState("");
  const [isTermsAccepted, setAcceptTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [disable, setdisable] = useState(true);
  const [showPassword] = useState(false);
  const [cms, setCms] = useState({});
  const [roleList, setRoleList] = useState([
    {
      value: "Individual",
      name: "Individual",
    },
    {
      value: "Organization",
      name: "Organization",
    },
  ]);
  const [role, setRole] = useState("");
  const [userRoleList, setUserRoleList] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [region, setRegion] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [otpValue, setOtpValue] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [isOtpShown, setIsOtpShown] = useState(false);
  const [isOtpVerify, setIsOtpVerify] = useState(false);
  const [verifyDisable, setVerifyDisable] = useState(true);
  const [timer, setTimer] = useState(0);
  const [isResendCodeDisable, setisResendCodeDisable] = useState(true);
  const [isResendButton, setIsResendButton] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showRoles, setShowRoles] = useState(false);
  const [otpErrorMsg, setErrorMsg] = useState(null);

  const selectedCountry = countries.find(
    (country) => country.phone === countryCode.slice(1),
  );
  const countryName = selectedCountry ? selectedCountry.label : "";

  const getCms = async () => {
    let cms = await getHomeCMS();
    setCms(cms.data);
    console.log(cms);
  };

  useEffect(() => {
    getCms();
  }, []);

  async function handleRegisterSubmit() {
    if (!username) {
      toast.warn("Please enter the username");
      return;
    }
    if (!email) {
      toast.warn("Please enter the email");
      return;
    }
    // Email validation using a regular expression
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      toast.warn("Please enter a valid email address.");
      return;
    }

    if (role == "Organization") {
      if (!organizationName) {
        toast.warn("Please enter Organization Name");
        return;
      }
      if (!organizationId) {
        toast.warn("Please enter Organization ID");
        return;
      }
      if (!userRole) {
        toast.warn("Please select User Role");
        return;
      }
    }
    if (!password) {
      toast.warn("Please enter the password");
      return;
    }
    if (!mobileNo) {
      toast.warn("Please enter the Mobile Number");
      return;
    }
    if (!isTermsAccepted) {
      toast.warn("Please accept the Terms & Conditions");
      return;
    }
    if (password.length < 6) {
      toast.warn("Password must contain at least 6 characters");
    } else {
      const hashedPassword = CryptoJS.SHA256(password).toString();
      let user = {
        username: username,
        email: email,
        password: hashedPassword,
        phone: countryCode + mobileNo,
        referedEmail:
          localStorage.getItem("referedEmail") !== "undefined" || null
            ? localStorage.getItem("referedEmail")
            : "",
        Role: role,
        organizationName: role == "Organization" ? organizationName : "",
        organizationId: role == "Organization" ? organizationId : "",
        userRole: role == "Organization" ? userRole : "",
        country: countryName,
      };
      console.log("user_", user);
      setLoading(true);
      const result = await userService.register(user);
      setLoading(false);
      console.log(result);
      if (result.status !== 201) {
        if (result?.Role == "Individual") {
          toast.info(result.message);
          history.push({
            pathname: `/afterRegistration`,
            state: { detail: user },
          });
        } else {
          toast.warn(result.message);
        }
      } else {
        localStorage.removeItem("referedEmail");
        localStorage.removeItem("accountType");
        toast.info(result.message);
        if (!result?.users) {
          history.push({
            pathname: `/afterRegistration`,
            state: { detail: user },
          });
        }
        try {
          const data = {
            userId: result?.data?._id,
            organizationId: result?.data?.organizationId,
            actionType: "signup",
          };
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
        } catch (error) {
          toast.error("Internal server error");
        }
      }
    }
  }

  function handleAcceptTerms(e) {
    console.log("value", e.target.checked);
    const isChecked = e.target.checked;
    setAcceptTerms(isChecked);
  }

  function handlePassword(e) {
    let pass = e.target.value;

    if (pass.length > 0) {
      if (pass.length <= 7) {
        setErrors("Password contains minimum 8 Characters");
        setIsPasswordValid(false);
      } else {
        setErrors("");

        var upperCaseLetters = /[A-Z]/g;
        var numbers = /[0-9]/g;
        var specialCharacters = /[!@#$%^&*(),.?":{}|<>]/g;
        if (!pass.match(upperCaseLetters)) {
          setErrors("Password contains at least 1 Capital letter");
          setIsPasswordValid(false);
        } else if (!pass.match(numbers)) {
          setErrors("Password contains at least 1 number");
          setIsPasswordValid(false);
        } else if (!pass.match(specialCharacters)) {
          setErrors("Password contains at least 1 special character");
          setIsPasswordValid(false);
        } else {
          setErrors("");
          setIsPasswordValid(true);
          setPassword(pass);
        }
      }
    } else {
      setErrors("");
      setIsPasswordValid(true);
    }
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // const handleRole = (e) => {
  //   console.log("eData_", e);
  //   setRole(e.target.value);
  // };
  const handleRole = (e) => {
    const selectedRole = e.target.value;
    setRole(selectedRole);
    if (selectedRole !== "Organization") {
      setUserRoleList([]);
      setUserRole("");
      setShowRoles(false);
    }
  };

  const handleUserRole = (e) => {
    console.log("eData_11111_", e);
    setUserRole(e.target.value);
  };

  const handleRegion = (e) => {
    console.log("handleRegion", e, region);
    setRegion(e.target.value);
  };

  const handleCountry = (event, value) => {
    console.log("params_", event, value);
    if (value.phone !== "" && mobileNo !== "") {
      setVerifyDisable(false);
      setIsOtpShown(false);
      setIsResendButton(false);
    } else {
      setVerifyDisable(true);
    }
    setCountryCode(`+${value.phone}`);
  };

  const handleNumber = (e) => {
    console.log("eData_", e, e.length, countryCode);

    // Map for country-specific phone number lengths
    const countryLengthMap = {
      "+1": 10,
      "+93": 9,
      "+355": 8,
      "+213": 9,
      "+376": 6,
      "+244": 9,
      "+1-264": 10,
      "+1-268": 10,
      "+54": 10,
      "+374": 8,
      "+297": 7,
      "+61": 9,
      "+43": 13,
      "+994": 9,
      "+1-242": 10,
      "+973": 8,
      "+880": 11,
      "+1-246": 10,
      "+32": 9,
      "+501": 8,
      "+229": 8,
      "+1-441": 10,
      "+975": 8,
      "+591": 8,
      "+387": 8,
      "+267": 7,
      "+55": 11,
      "+1-284": 10,
      "+673": 7,
      "+359": 8,
      "+226": 8,
      "+257": 7,
      "+855": 8,
      "+237": 9,
      "+1": 10,
      "+238": 7,
      "+1-345": 10,
      "+236": 7,
      "+235": 8,
      "+56": 9,
      "+86": 11,
      "+57": 10,
      "+269": 7,
      "+242": 7,
      "+243": 9,
      "+682": 5,
      "+506": 8,
      "+225": 10,
      "+385": 9,
      "+53": 8,
      "+599": 7,
      "+357": 8,
      "+420": 9,
      "+45": 8,
      "+253": 6,
      "+1-767": 10,
      "+1-809": 10,
      "+593": 9,
      "+20": 10,
      "+503": 8,
      "+240": 9,
      "+291": 7,
      "+368": 6,
      "+251": 10,
      "+500": 4,
      "+298": 6,
      "+679": 7,
      "+358": 9,
      "+33": 9,
      "+594": 9,
      "+689": 6,
      "+241": 7,
      "+220": 7,
      "+995": 9,
      "+49": 11,
      "+233": 10,
      "+350": 5,
      "+30": 10,
      "+299": 6,
      "+1-473": 10,
      "+590": 10,
      "+1-671": 10,
      "+502": 8,
      "+224": 9,
      "+245": 9,
      "+595": 9,
      "+509": 9,
      "+379": 13,
      "+504": 8,
      "+852": 8,
      "+36": 9,
      "+354": 7,
      "+91": 10,
      "+62": 10,
      "+98": 10,
      "+964": 10,
      "+353": 9,
      "+972": 9,
      "+39": 10,
      "+1-876": 10,
      "+81": 10,
      "+44": 10,
      "+962": 9,
      "+7": 10,
      "+254": 10,
      "+686": 5,
      "+965": 8,
      "+996": 9,
      "+856": 8,
      "+371": 8,
      "+961": 8,
      "+266": 8,
      "+231": 7,
      "+218": 10,
      "+423": 7,
      "+370": 8,
      "+352": 8,
      "+261": 10,
      "+265": 8,
      "+60": 10,
      "+960": 7,
      "+223": 8,
      "+356": 8,
      "+692": 7,
      "+596": 10,
      "+222": 9,
      "+230": 8,
      "+262": 10,
      "+52": 10,
      "+691": 7,
      "+373": 8,
      "+377": 8,
      "+976": 8,
      "+1-664": 10,
      "+212": 9,
      "+258": 9,
      "+95": 9,
      "+264": 9,
      "+674": 8,
      "+977": 10,
      "+31": 9,
      "+599": 10,
      "+687": 6,
      "+64": 9,
      "+505": 8,
      "+227": 8,
      "+234": 10,
      "+683": 5,
      "+850": 8,
      "+1-670": 10,
      "+47": 8,
      "+968": 8,
      "+92": 10,
      "+680": 7,
      "+970": 9,
      "+507": 8,
      "+675": 7,
      "+595": 8,
      "+51": 9,
      "+63": 10,
      "+48": 9,
      "+351": 9,
      "+1-787": 10,
      "+974": 8,
      "+40": 10,
      "+7": 10,
      "+250": 10,
      "+590": 10,
      "+1-869": 10,
      "+1-758": 10,
      "+1-784": 10,
      "+685": 5,
      "+378": 10,
      "+239": 7,
      "+966": 9,
      "+221": 9,
      "+381": 9,
      "+248": 7,
      "+232": 8,
      "+65": 8,
      "+421": 9,
      "+386": 8,
      "+677": 6,
      "+252": 8,
      "+27": 10,
      "+82": 10,
      "+211": 9,
      "+34": 9,
      "+94": 10,
      "+249": 10,
      "+597": 8,
      "+268": 7,
      "+41": 9,
      "+963": 9,
      "+886": 10,
      "+992": 9,
      "+255": 10,
      "+66": 9,
      "+670": 7,
      "+228": 8,
      "+690": 6,
      "+676": 4,
      "+1-868": 10,
      "+216": 8,
      "+90": 10,
      "+993": 9,
      "+1-649": 10,
      "+688": 5,
      "+256": 10,
      "+380": 9,
      "+971": 9,
      "+44": 10,
      "+1": 10,
      "+598": 8,
      "+998": 9,
      "+678": 5,
      "+379": 13,
      "+58": 10,
      "+84": 10,
      "+681": 4,
      "+212": 9,
      "+967": 9,
      "+260": 10,
      "+263": 9,
      "+1684": 7,
      "+358-18": 9,
      "+590": 10,
      "+375": 9,
      "+501": 8,
      "+383": 9,
      "+1-340": 10,
      "+1-284": 10,
      "+690": 4,
      "+262": 9,
      "+235": 8,
      "+239": 7,
      "+268": 7,
      "+290": 4,
      "+46": 10,
      "+262": 9,
      "+872": 9,
      "+382": 9,
      "+389": 9,
      "+269": 7,
      "+44": 10,
      "+44": 10,
      "+672": 6,
      "+592": 9,
      "+500": 4,
      "+500": 4,
    };

    const maxLength = countryLengthMap[countryCode] || 10;

    if (e.length > maxLength) {
      return;
    }

    if (e.length < maxLength && e.length > 0) {
      setErrorMessage(`Please enter a ${maxLength} digit phone number.`);
    } else {
      setErrorMessage("");
    }

    let isChina = e.length === 11 && countryCode === "+86";
    let isOtherCountries =
      e.length === maxLength && countryCode !== "+86" && countryCode !== "";

    if (isChina || isOtherCountries) {
      setVerifyDisable(false);
      setIsOtpShown(false);
      setIsResendButton(false);
    } else {
      setVerifyDisable(true);
    }

    setMobileNo(e);
  };

  const handleOTP = async (e) => {
    console.log("otpdata_", e.length, e);
    setOtpValue(e);

    if (e.length == 6) {
      setLoading(true);
      let payload = {
        phone: countryCode + mobileNo,
        otp: e,
      };
      let verifyOtpresponse = await verifyOtp(payload);
      console.log("verifyOtp_", verifyOtpresponse);
      if (verifyOtpresponse.status == 200) {
        setLoading(false);
        setIsOtpShown(false);
        setIsOtpVerify(true);
        setVerifyDisable(true);
        setdisable(false);
        setisResendCodeDisable(false);
        setIsResendButton(false);
      } else if (verifyOtpresponse.status == 400) {
        console.log("bnbnbnb");
        setLoading(false);
        setIsOtpVerify(false);
        setIsOtpShown(true);
        setisResendCodeDisable(true);
        setIsResendButton(true);
        setErrorMsg(verifyOtpresponse.message);
        return;
      } else if (verifyOtpresponse.status == 429) {
        console.log("bnbvvnbnb");
        setLoading(false);
        setIsOtpVerify(false);
        setIsOtpShown(true);
        setisResendCodeDisable(true);
        setIsResendButton(true);
        setErrorMsg(verifyOtpresponse.message);
        return;
      } else {
        setLoading(false);
        setIsOtpVerify(false);
        setIsOtpShown(true);
        setisResendCodeDisable(true);
        setIsResendButton(true);
      }
    }
  };

  const handleVerify = async () => {
    console.log("resendOTP");
    setOtpValue("");
    setTimer(60);
    setIsOtpVerify(false);

    if (!role) {
      toast.warn("Please select role.");
      return;
    }
    if (!isPasswordValid) {
      toast.warn("Please enter a valid password.");
      return;
    }
    if (!username) {
      toast.warn("Please enter the username");
      return;
    }
    if (!email) {
      toast.warn("Please enter the email");
      return;
    }
    if (role == "Organization") {
      if (!organizationName) {
        toast.warn("Please enter Organization Name");
        return;
      }
      if (!organizationId) {
        toast.warn("Please enter Organization ID");
        return;
      }
      if (!userRole) {
        toast.warn("Please select User Role");
        return;
      }
    }
    if (!password) {
      toast.warn("Please enter the password");
      return;
    }
    if (!mobileNo) {
      toast.warn("Please enter the Mobile Number");
      return;
    }

    let payload = {
      phone: countryCode + mobileNo,
    };

    let otpStatusResponse = await checkOtpStatus(payload);
    if (otpStatusResponse.status === 200) {
      let otpDetails = otpStatusResponse.data;
      let currentTime = new Date();

      if (
        otpDetails.lockUntil &&
        new Date(otpDetails.lockUntil) > currentTime &&
        otpDetails.attempts == 3
      ) {
        let unlockTime = new Date(otpDetails.lockUntil).toLocaleString();
        toast.warn(
          `You are locked due to failed attempts. Try again after ${unlockTime}.`,
        );
        return;
      }

      if (
        otpDetails.lockUntil &&
        new Date(otpDetails.lockUntil) > currentTime
      ) {
        let unlockTime = new Date(otpDetails.lockUntil).toLocaleString();
        toast.warn(
          `You are locked due to failed attempts. Try again after ${unlockTime}.`,
        );
        return;
      }
    }

    let sentresponse = await sendOtp(payload);
    console.log("sentresponse_", sentresponse.message);

    if (sentresponse.status == 200) {
      toast.success("OTP Sent Successfully");
      setIsResendButton(true);
      setIsOtpShown(true);
      setVerifyDisable(true);
    } else {
      toast.warn("Invalid Phone Number");
      return;
    }
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
    }, 1000);
    if (timer == 0) {
      setisResendCodeDisable(false);
      setIsOtpShown(false);
    } else {
      setisResendCodeDisable(true);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [timer]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    fetchCountryList();
  }, []);

  const fetchCountryList = () => {
    let finalArr = [];
    countries.map((obj) => {
      finalArr.push({
        name: obj.label,
        value: obj.label,
      });
    });
    setCountryList(finalArr);
  };

  //   const getUserRoles = async () => {
  //   try {
  //     console.log("👉 getUserRoles function triggered");

  //     if (organizationId) {
  //       console.log("📌 Organization ID:", organizationId);

  //       setLoading(true);
  //       console.log("⏳ Loading started");

  //       const data = { organizationId };
  //       console.log("📤 Request Payload:", data);

  //       const checkUsersExist = await getRoles(data);
  //       console.log("📥 API Response:", checkUsersExist);

  //       if (checkUsersExist?.isUsersExist) {
  //         console.log("✅ Users exist:", checkUsersExist.isUsersExist);
  //         console.log("👥 Role List:", checkUsersExist.userRoleList);

  //         setUserRoleList(checkUsersExist?.userRoleList);
  //       } else {
  //         console.log("⚠️ No users exist OR flag is false");
  //         console.log("👥 Role List (fallback):", checkUsersExist?.userRoleList);

  //         setUserRoleList(checkUsersExist?.userRoleList);
  //       }

  //       setShowRoles(true);
  //       console.log("👀 Show Roles set to TRUE");

  //       setLoading(false);
  //       console.log("✅ Loading finished");
  //     } else {
  //       console.log("❌ organizationId is missing or undefined");
  //     }
  //   } catch (error) {
  //     console.error("🚨 Error finding roles list:", error);
  //     setLoading(false);
  //     console.log("❌ Loading stopped due to error");
  //   }
  // };

  const getUserRoles = async () => {
    try {
      if (organizationId) {
        setLoading(true);

        const data = { organizationId };

        const response = await getRoles(data);

        // ✅ IMPORTANT FIX
        const result = response?.data || response;

        console.log("API RESULT 👉", result);

        setUserRoleList(result?.userRoleList || []);
        setShowRoles(true);

        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!organizationId || role !== "Organization") {
      setShowRoles(false);
      setUserRoleList([]);
      return;
    }
    getUserRoles();
    // const timer = setTimeout(() => {
    //   getUserRoles();
    // }, 2000);

    return () => clearTimeout(timer);
  }, [organizationId, role]);

  return (
    <>
      {/* Inject custom styles */}
      <style>{customStyles}</style>

      {/* Animated Background */}
      <div className="animated-background"></div>

      {/* Floating Shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="shape shape-6"></div>

        {/* Bubbles */}
        <div className="bubble bubble-1"></div>
        <div className="bubble bubble-2"></div>
        <div className="bubble bubble-3"></div>
        <div className="bubble bubble-4"></div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Loader loading={loading} />

      {/* Logo */}
      <div className="petLogoContainer">
        <Link to="/">
          <img src={PoetNewlogopen} alt="Logo" className="petLogo" />
        </Link>
      </div>

      {/* MUI Grid v2 Container */}
      <Grid
        container
        spacing={0}
        className="grid-container"
        alignItems="center"
        justifyContent="center"
        sx={{
          minHeight: "100vh",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid
          xs={12}
          sm={10}
          md={8}
          lg={6}
          xl={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card className="signup-card px-4 p-4">
            <div className="text-center">
              <h3 className="mainHeading">Signup</h3>
            </div>

            <div className="mt-1 py-1">
              <SelectDropdownMui
                optionsList={roleList}
                selectLabel={"Role"}
                onChange={handleRole}
                value={role}
              />
            </div>

            {role == "Organization" && (
              <>
                <div className="mt-2 py-1">
                  <InputBoxMui
                    fullWidth
                    type="text"
                    label="Organization*"
                    onChange={(e) => setOrganizationName(e.target.value)}
                  />
                </div>

                <div className="mt-2 py-1">
                  <InputBoxMui
                    fullWidth
                    type="text"
                    label="Organization ID*"
                    onChange={(e) => {
                      setOrganizationId(e.target.value);
                      setUserRole("");
                      setShowRoles(false);
                    }}
                  />
                </div>

                {organizationId && showRoles && (
                  <div className="mt-2 py-1">
                    <SelectDropdownMui
                      optionsList={userRoleList}
                      selectLabel={"User Role"}
                      onChange={handleUserRole}
                      value={userRole}
                    />
                  </div>
                )}
              </>
            )}

            <div className="mt-2 py-1">
              <InputBoxMui
                fullWidth
                type="text"
                label="Username*"
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>

            <div className="mt-2 py-1">
              <InputBoxMui
                fullWidth
                type="email"
                label="Email*"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="mt-2 py-1">
              <InputBoxPasswordMui
                fullWidth
                label="Password*"
                type={values.showPassword ? "text" : "password"}
                value={values.password}
                onChange={(e) => handlePassword(e)}
              />
              <p
                className="p-2"
                style={{
                  color: "#f44336",
                  fontSize: "10px",
                  textAlign: "left",
                }}
              >
                {errors}
              </p>
            </div>

            <div className="mt-1.5 py-1">
              <Grid container spacing={2} alignItems="center">
                <Grid xs={12} sm={8}>
                  <InputBoxMobile
                    onChange={(e) => handleNumber(e)}
                    handleCountryCode={handleCountry}
                    value={mobileNo}
                  />
                </Grid>
                <Grid xs={12} sm={4}>
                  <Button
                    variant="primary"
                    className="loginBtnVerify w-100"
                    disabled={verifyDisable}
                    onClick={handleVerify}
                  >
                    Verify
                  </Button>
                </Grid>
                {errorMessage && (
                  <Grid xs={12}>
                    <div className="text-danger mt-2">{errorMessage}</div>
                  </Grid>
                )}
              </Grid>
            </div>

            {isOtpShown && (
              <>
                <div className="mt-2 d-flex justify-content-center">
                  <OtpInputBox
                    value={otpValue}
                    onChange={(e) => handleOTP(e)}
                  />
                </div>
                {!isOtpVerify && otpValue?.length == 6 && (
                  <div>
                    {otpErrorMsg && (
                      <p className="errorMsg mt-1">{otpErrorMsg}</p>
                    )}
                  </div>
                )}
              </>
            )}

            <div className="mt-2 d-flex align-items-center justify-content-between">
              {isResendButton && (
                <Button
                  className="otpresend"
                  onClick={handleVerify}
                  disabled={isResendCodeDisable}
                >
                  Resend Code
                </Button>
              )}
              {isOtpShown && <p className="ml-5 mb-0">{formatTime(timer)}</p>}
            </div>

            {isOtpVerify && (
              <div className="d-flex align-items-center mt-2">
                <p className="verifyMsg mb-0">Phone Number Verified</p>
                <img className="tickicon ml-2" src={tick} alt="verified" />
              </div>
            )}

            <div className="mt-1.5">
              <CheckboxMui
                label="I agree with terms and conditions"
                isChecked={isTermsAccepted}
                onChange={(e) => handleAcceptTerms(e)}
              />
            </div>

            <div className="text-center mt-1">
              <Button
                variant="primary"
                className="loginBtnRegister"
                disabled={disable}
                onClick={handleRegisterSubmit}
              >
                Sign up
              </Button>
            </div>

            <div className="text-center mt-3">
              <p className="mb-0" style={{ color: "#000000", fontWeight: 500 }}>
                Already have an account?{" "}
                <Link to="/login" className="signinLink">
                  Login
                </Link>
              </p>
            </div>

            <div className="text-center mt-2">
              <Link to="/privacypolicy" target="_blank" className="privacyLink">
                Term of use. Privacy policy
              </Link>
            </div>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default withRouter(SignUp);
